/* tslint:disable */
/* eslint-disable */
/**
 * Access Control API
 * API for managing users, roles, tenants, and features.
 *
 * The version of the OpenAPI document: 0.0.0
 * Contact: support@digiwedge.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common.js';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base.js';
export const CreatePermissionAssignmentDtoSubjectTypeEnum = {
    User: 'USER',
    Role: 'ROLE',
    Tenant: 'TENANT'
};
export const FeatureFlagResponseDtoSubjectTypeEnum = {
    User: 'USER',
    Role: 'ROLE',
    Tenant: 'TENANT'
};
export const MfaCleanupDtoMethodEnum = {
    Sms: 'sms',
    Email: 'email',
    Whatsapp: 'whatsapp',
    Authenticator: 'authenticator',
    Backup: 'backup'
};
export const MfaRecordDtoMethodEnum = {
    Sms: 'sms',
    Email: 'email',
    Whatsapp: 'whatsapp',
    Authenticator: 'authenticator',
    Backup: 'backup'
};
export const PermissionAssignmentResponseDtoSubjectTypeEnum = {
    User: 'USER',
    Role: 'ROLE',
    Tenant: 'TENANT'
};
export const ProvisionInitialUserDtoRoleEnum = {
    TenantOwner: 'TENANT_OWNER',
    TenantAdmin: 'TENANT_ADMIN',
    VoiceproEditor: 'VOICEPRO_EDITOR',
    VoiceproViewer: 'VOICEPRO_VIEWER',
    CrmAdmin: 'CRM_ADMIN',
    CrmViewer: 'CRM_VIEWER',
    FacilitiesAdmin: 'facilities.admin',
    FacilitiesLeasingAdmin: 'facilities.leasing.admin',
    FacilitiesLeasingViewer: 'facilities.leasing.viewer',
    FacilitiesLeasingWorkflowOperator: 'facilities.leasing.workflow.operator',
    FacilitiesLeasingApplicantAccessManager: 'facilities.leasing.applicant-access.manager',
    FacilitiesLeasingDocumentReviewer: 'facilities.leasing.document-reviewer',
    FacilitiesLeasingDesignReviewer: 'facilities.leasing.design-reviewer',
    FacilitiesLeasingCatalogManager: 'facilities.leasing.catalog-manager',
    FacilitiesLeasingCommercialApprover: 'facilities.leasing.commercial-approver',
    FacilitiesLeasingFinanceDepositOperator: 'facilities.leasing.finance-deposit.operator',
    FacilitiesLeasingContractPermitOperator: 'facilities.leasing.contract-permit.operator'
};
export const ProvisionTenantDtoTemplateIdEnum = {
    VoiceproCustomer: 'voicepro-customer',
    VoiceproOperator: 'voicepro-operator',
    Corporate: 'corporate',
    FacilitiesLeasing: 'facilities-leasing'
};
export const ProvisionTenantJobResponseDtoStatusEnum = {
    Pending: 'pending',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed'
};
export const ProvisionTenantJobStatusDtoStatusEnum = {
    Pending: 'pending',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed'
};
export const ProvisionTenantResponseDtoTemplateIdEnum = {
    VoiceproCustomer: 'voicepro-customer',
    VoiceproOperator: 'voicepro-operator',
    Corporate: 'corporate',
    FacilitiesLeasing: 'facilities-leasing'
};
export const ProvisioningJobErrorDtoStepIdEnum = {
    CreateTenant: 'create-tenant',
    SetupRegistry: 'setup-registry',
    CreateUsers: 'create-users',
    Finalize: 'finalize'
};
export const ProvisioningStepDtoIdEnum = {
    CreateTenant: 'create-tenant',
    SetupRegistry: 'setup-registry',
    CreateUsers: 'create-users',
    Finalize: 'finalize'
};
export const ProvisioningStepDtoStatusEnum = {
    Pending: 'pending',
    InProgress: 'in-progress',
    Completed: 'completed',
    Failed: 'failed'
};
export const SessionResponseDtoSessionTypeEnum = {
    Access: 'ACCESS',
    Refresh: 'REFRESH',
    Oauth: 'OAUTH',
    Other: 'OTHER'
};
export const UserResponseDtoStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    LockedOut: 'LOCKED_OUT',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED',
    PendingVerification: 'PENDING_VERIFICATION',
    Deleted: 'DELETED'
};
export const UsersControllerUpdateUserStatusRequestStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    LockedOut: 'LOCKED_OUT',
    Suspended: 'SUSPENDED',
    Banned: 'BANNED',
    PendingVerification: 'PENDING_VERIFICATION',
    Deleted: 'DELETED'
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfoControllerGetBuildInfo: async (options = {}) => {
            const localVarPath = `/api/admin/build-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildInfoControllerGetBuildInfo(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildInfoControllerGetBuildInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.buildInfoControllerGetBuildInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfoControllerGetBuildInfo(options) {
            return localVarFp.buildInfoControllerGetBuildInfo(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    buildInfoControllerGetBuildInfo(options) {
        return AdminApiFp(this.configuration).buildInfoControllerGetBuildInfo(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuditLogsApi - axios parameter creator
 * @export
 */
export const AuditLogsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a single audit log entry by its unique identifier.
         * @summary Get audit log by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogControllerGetAuditLogById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('auditLogControllerGetAuditLogById', 'id', id);
            const localVarPath = `/api/audit-logs/{id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns audit log entries for account deletion, restoration, and permanent deletion events.
         * @summary Get account deletion audit logs
         * @param {string} tenantId Tenant ID to filter logs
         * @param {string} [userId] Optional user ID to filter by specific user
         * @param {AuditLogControllerGetDeletionAuditLogsActionEnum} [action] Filter by specific deletion action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogControllerGetDeletionAuditLogs: async (tenantId, userId, action, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('auditLogControllerGetDeletionAuditLogs', 'tenantId', tenantId);
            const localVarPath = `/api/audit-logs/deletions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuditLogsApi - functional programming interface
 * @export
 */
export const AuditLogsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuditLogsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a single audit log entry by its unique identifier.
         * @summary Get audit log by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditLogControllerGetAuditLogById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditLogControllerGetAuditLogById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogsApi.auditLogControllerGetAuditLogById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns audit log entries for account deletion, restoration, and permanent deletion events.
         * @summary Get account deletion audit logs
         * @param {string} tenantId Tenant ID to filter logs
         * @param {string} [userId] Optional user ID to filter by specific user
         * @param {AuditLogControllerGetDeletionAuditLogsActionEnum} [action] Filter by specific deletion action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditLogControllerGetDeletionAuditLogs(tenantId, userId, action, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditLogControllerGetDeletionAuditLogs(tenantId, userId, action, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogsApi.auditLogControllerGetDeletionAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AuditLogsApi - factory interface
 * @export
 */
export const AuditLogsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuditLogsApiFp(configuration);
    return {
        /**
         * Returns a single audit log entry by its unique identifier.
         * @summary Get audit log by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogControllerGetAuditLogById(id, options) {
            return localVarFp.auditLogControllerGetAuditLogById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns audit log entries for account deletion, restoration, and permanent deletion events.
         * @summary Get account deletion audit logs
         * @param {string} tenantId Tenant ID to filter logs
         * @param {string} [userId] Optional user ID to filter by specific user
         * @param {AuditLogControllerGetDeletionAuditLogsActionEnum} [action] Filter by specific deletion action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogControllerGetDeletionAuditLogs(tenantId, userId, action, options) {
            return localVarFp.auditLogControllerGetDeletionAuditLogs(tenantId, userId, action, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuditLogsApi - object-oriented interface
 * @export
 * @class AuditLogsApi
 * @extends {BaseAPI}
 */
export class AuditLogsApi extends BaseAPI {
    /**
     * Returns a single audit log entry by its unique identifier.
     * @summary Get audit log by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    auditLogControllerGetAuditLogById(id, options) {
        return AuditLogsApiFp(this.configuration).auditLogControllerGetAuditLogById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns audit log entries for account deletion, restoration, and permanent deletion events.
     * @summary Get account deletion audit logs
     * @param {string} tenantId Tenant ID to filter logs
     * @param {string} [userId] Optional user ID to filter by specific user
     * @param {AuditLogControllerGetDeletionAuditLogsActionEnum} [action] Filter by specific deletion action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    auditLogControllerGetDeletionAuditLogs(tenantId, userId, action, options) {
        return AuditLogsApiFp(this.configuration).auditLogControllerGetDeletionAuditLogs(tenantId, userId, action, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const AuditLogControllerGetDeletionAuditLogsActionEnum = {
    UserDeleted: 'USER_DELETED',
    UserRestored: 'USER_RESTORED',
    UserPermanentlyDeleted: 'USER_PERMANENTLY_DELETED'
};
/**
 * CapabilitiesApi - axios parameter creator
 * @export
 */
export const CapabilitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Batch check permissions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capabilitiesControllerCan: async (options = {}) => {
            const localVarPath = `/api/capabilities/can`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CapabilitiesApi - functional programming interface
 * @export
 */
export const CapabilitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CapabilitiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Batch check permissions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async capabilitiesControllerCan(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.capabilitiesControllerCan(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CapabilitiesApi.capabilitiesControllerCan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CapabilitiesApi - factory interface
 * @export
 */
export const CapabilitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CapabilitiesApiFp(configuration);
    return {
        /**
         *
         * @summary Batch check permissions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        capabilitiesControllerCan(options) {
            return localVarFp.capabilitiesControllerCan(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CapabilitiesApi - object-oriented interface
 * @export
 * @class CapabilitiesApi
 * @extends {BaseAPI}
 */
export class CapabilitiesApi extends BaseAPI {
    /**
     *
     * @summary Batch check permissions for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapabilitiesApi
     */
    capabilitiesControllerCan(options) {
        return CapabilitiesApiFp(this.configuration).capabilitiesControllerCan(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConsentsApi - axios parameter creator
 * @export
 */
export const ConsentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create or request consent for a user
         * @param {CreateConsentDto} createConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerCreate: async (createConsentDto, options = {}) => {
            // verify required parameter 'createConsentDto' is not null or undefined
            assertParamExists('consentsControllerCreate', 'createConsentDto', createConsentDto);
            const localVarPath = `/api/consents/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createConsentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all consent records
         * @param {string} [tenantId] Filter by tenant ID
         * @param {string} [userId] Filter by user ID
         * @param {boolean} [includeRevoked] Include revoked consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerFindAll: async (tenantId, userId, includeRevoked, options = {}) => {
            const localVarPath = `/api/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (includeRevoked !== undefined) {
                localVarQueryParameter['includeRevoked'] = includeRevoked;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a consent record by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerFindById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('consentsControllerFindById', 'id', id);
            const localVarPath = `/api/consents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke consent for a user
         * @param {RevokeConsentDto} revokeConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerRevoke: async (revokeConsentDto, options = {}) => {
            // verify required parameter 'revokeConsentDto' is not null or undefined
            assertParamExists('consentsControllerRevoke', 'revokeConsentDto', revokeConsentDto);
            const localVarPath = `/api/consents/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(revokeConsentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing consent record
         * @param {UpdateConsentDto} updateConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerUpdate: async (updateConsentDto, options = {}) => {
            // verify required parameter 'updateConsentDto' is not null or undefined
            assertParamExists('consentsControllerUpdate', 'updateConsentDto', updateConsentDto);
            const localVarPath = `/api/consents/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateConsentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ConsentsApi - functional programming interface
 * @export
 */
export const ConsentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConsentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create or request consent for a user
         * @param {CreateConsentDto} createConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerCreate(createConsentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerCreate(createConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List all consent records
         * @param {string} [tenantId] Filter by tenant ID
         * @param {string} [userId] Filter by user ID
         * @param {boolean} [includeRevoked] Include revoked consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerFindAll(tenantId, userId, includeRevoked, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerFindAll(tenantId, userId, includeRevoked, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a consent record by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerFindById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerFindById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerFindById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Revoke consent for a user
         * @param {RevokeConsentDto} revokeConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerRevoke(revokeConsentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerRevoke(revokeConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerRevoke']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing consent record
         * @param {UpdateConsentDto} updateConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentsControllerUpdate(updateConsentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentsControllerUpdate(updateConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentsApi.consentsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ConsentsApi - factory interface
 * @export
 */
export const ConsentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConsentsApiFp(configuration);
    return {
        /**
         *
         * @summary Create or request consent for a user
         * @param {CreateConsentDto} createConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerCreate(createConsentDto, options) {
            return localVarFp.consentsControllerCreate(createConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all consent records
         * @param {string} [tenantId] Filter by tenant ID
         * @param {string} [userId] Filter by user ID
         * @param {boolean} [includeRevoked] Include revoked consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerFindAll(tenantId, userId, includeRevoked, options) {
            return localVarFp.consentsControllerFindAll(tenantId, userId, includeRevoked, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a consent record by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerFindById(id, options) {
            return localVarFp.consentsControllerFindById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Revoke consent for a user
         * @param {RevokeConsentDto} revokeConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerRevoke(revokeConsentDto, options) {
            return localVarFp.consentsControllerRevoke(revokeConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing consent record
         * @param {UpdateConsentDto} updateConsentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentsControllerUpdate(updateConsentDto, options) {
            return localVarFp.consentsControllerUpdate(updateConsentDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConsentsApi - object-oriented interface
 * @export
 * @class ConsentsApi
 * @extends {BaseAPI}
 */
export class ConsentsApi extends BaseAPI {
    /**
     *
     * @summary Create or request consent for a user
     * @param {CreateConsentDto} createConsentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerCreate(createConsentDto, options) {
        return ConsentsApiFp(this.configuration).consentsControllerCreate(createConsentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all consent records
     * @param {string} [tenantId] Filter by tenant ID
     * @param {string} [userId] Filter by user ID
     * @param {boolean} [includeRevoked] Include revoked consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerFindAll(tenantId, userId, includeRevoked, options) {
        return ConsentsApiFp(this.configuration).consentsControllerFindAll(tenantId, userId, includeRevoked, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a consent record by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerFindById(id, options) {
        return ConsentsApiFp(this.configuration).consentsControllerFindById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Revoke consent for a user
     * @param {RevokeConsentDto} revokeConsentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerRevoke(revokeConsentDto, options) {
        return ConsentsApiFp(this.configuration).consentsControllerRevoke(revokeConsentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing consent record
     * @param {UpdateConsentDto} updateConsentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConsentsApi
     */
    consentsControllerUpdate(updateConsentDto, options) {
        return ConsentsApiFp(this.configuration).consentsControllerUpdate(updateConsentDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeatureFlagsApi - axios parameter creator
 * @export
 */
export const FeatureFlagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new FeatureFlag (link feature to user/role/tenant)
         * @param {CreateFeatureFlagDto} createFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerCreateFeatureFlag: async (createFeatureFlagDto, options = {}) => {
            // verify required parameter 'createFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerCreateFeatureFlag', 'createFeatureFlagDto', createFeatureFlagDto);
            const localVarPath = `/api/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureFlagDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerPermanentlyDeleteFeatureFlag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerPermanentlyDeleteFeatureFlag', 'id', id);
            const localVarPath = `/api/feature-flags/{id}/permanent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerRestoreFeatureFlag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerRestoreFeatureFlag', 'id', id);
            const localVarPath = `/api/feature-flags/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft-delete a FeatureFlag by ID
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerSoftDeleteFeatureFlag: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsControllerSoftDeleteFeatureFlag', 'id', id);
            const localVarPath = `/api/feature-flags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing FeatureFlag (e.g., enablement)
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateFeatureFlag: async (updateFeatureFlagDto, options = {}) => {
            // verify required parameter 'updateFeatureFlagDto' is not null or undefined
            assertParamExists('featureFlagsControllerUpdateFeatureFlag', 'updateFeatureFlagDto', updateFeatureFlagDto);
            const localVarPath = `/api/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureFlagDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a FeatureFlag by its ID
         * @param {any} id FeatureFlag ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featureFlagsQueryControllerGetFeatureFlagById', 'id', id);
            const localVarPath = `/api/feature-flags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List FeatureFlags by enabled=true/false
         * @param {boolean} enabled
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagsByEnabledState: async (enabled, take, skip, options = {}) => {
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('featureFlagsQueryControllerGetFeatureFlagsByEnabledState', 'enabled', enabled);
            const localVarPath = `/api/feature-flags/enabled-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List FeatureFlags by userId, roleId, or tenantId
         * @param {number} [take]
         * @param {number} [skip]
         * @param {string} [tenantId]
         * @param {string} [roleId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagsByEntity: async (take, skip, tenantId, roleId, userId, options = {}) => {
            const localVarPath = `/api/feature-flags/by-entity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List FeatureFlags by featureId
         * @param {any} featureId The feature ID to filter by.
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagsByFeature: async (featureId, take, skip, options = {}) => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('featureFlagsQueryControllerGetFeatureFlagsByFeature', 'featureId', featureId);
            const localVarPath = `/api/feature-flags/by-feature/{featureId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve non-deleted FeatureFlags (optional pagination)
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetNonDeletedFeatureFlags: async (take, skip, options = {}) => {
            const localVarPath = `/api/feature-flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeatureFlagsApi - functional programming interface
 * @export
 */
export const FeatureFlagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeatureFlagsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new FeatureFlag (link feature to user/role/tenant)
         * @param {CreateFeatureFlagDto} createFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerCreateFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerPermanentlyDeleteFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerRestoreFeatureFlag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerRestoreFeatureFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerRestoreFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft-delete a FeatureFlag by ID
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerSoftDeleteFeatureFlag(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerSoftDeleteFeatureFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerSoftDeleteFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing FeatureFlag (e.g., enablement)
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsControllerUpdateFeatureFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a FeatureFlag by its ID
         * @param {any} id FeatureFlag ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsQueryControllerGetFeatureFlagById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsQueryControllerGetFeatureFlagById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsQueryControllerGetFeatureFlagById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List FeatureFlags by enabled=true/false
         * @param {boolean} enabled
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsQueryControllerGetFeatureFlagsByEnabledState(enabled, take, skip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsQueryControllerGetFeatureFlagsByEnabledState(enabled, take, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsQueryControllerGetFeatureFlagsByEnabledState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List FeatureFlags by userId, roleId, or tenantId
         * @param {number} [take]
         * @param {number} [skip]
         * @param {string} [tenantId]
         * @param {string} [roleId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsQueryControllerGetFeatureFlagsByEntity(take, skip, tenantId, roleId, userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsQueryControllerGetFeatureFlagsByEntity(take, skip, tenantId, roleId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsQueryControllerGetFeatureFlagsByEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List FeatureFlags by featureId
         * @param {any} featureId The feature ID to filter by.
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsQueryControllerGetFeatureFlagsByFeature(featureId, take, skip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsQueryControllerGetFeatureFlagsByFeature(featureId, take, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsQueryControllerGetFeatureFlagsByFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve non-deleted FeatureFlags (optional pagination)
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureFlagsQueryControllerGetNonDeletedFeatureFlags(take, skip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureFlagsQueryControllerGetNonDeletedFeatureFlags(take, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagsApi.featureFlagsQueryControllerGetNonDeletedFeatureFlags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeatureFlagsApi - factory interface
 * @export
 */
export const FeatureFlagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeatureFlagsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new FeatureFlag (link feature to user/role/tenant)
         * @param {CreateFeatureFlagDto} createFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options) {
            return localVarFp.featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options) {
            return localVarFp.featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted FeatureFlag
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerRestoreFeatureFlag(id, options) {
            return localVarFp.featureFlagsControllerRestoreFeatureFlag(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft-delete a FeatureFlag by ID
         * @param {string} id FeatureFlag ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerSoftDeleteFeatureFlag(id, options) {
            return localVarFp.featureFlagsControllerSoftDeleteFeatureFlag(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing FeatureFlag (e.g., enablement)
         * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options) {
            return localVarFp.featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a FeatureFlag by its ID
         * @param {any} id FeatureFlag ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagById(id, options) {
            return localVarFp.featureFlagsQueryControllerGetFeatureFlagById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List FeatureFlags by enabled=true/false
         * @param {boolean} enabled
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagsByEnabledState(enabled, take, skip, options) {
            return localVarFp.featureFlagsQueryControllerGetFeatureFlagsByEnabledState(enabled, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List FeatureFlags by userId, roleId, or tenantId
         * @param {number} [take]
         * @param {number} [skip]
         * @param {string} [tenantId]
         * @param {string} [roleId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagsByEntity(take, skip, tenantId, roleId, userId, options) {
            return localVarFp.featureFlagsQueryControllerGetFeatureFlagsByEntity(take, skip, tenantId, roleId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List FeatureFlags by featureId
         * @param {any} featureId The feature ID to filter by.
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetFeatureFlagsByFeature(featureId, take, skip, options) {
            return localVarFp.featureFlagsQueryControllerGetFeatureFlagsByFeature(featureId, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve non-deleted FeatureFlags (optional pagination)
         * @param {number} [take]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureFlagsQueryControllerGetNonDeletedFeatureFlags(take, skip, options) {
            return localVarFp.featureFlagsQueryControllerGetNonDeletedFeatureFlags(take, skip, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeatureFlagsApi - object-oriented interface
 * @export
 * @class FeatureFlagsApi
 * @extends {BaseAPI}
 */
export class FeatureFlagsApi extends BaseAPI {
    /**
     *
     * @summary Create a new FeatureFlag (link feature to user/role/tenant)
     * @param {CreateFeatureFlagDto} createFeatureFlagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsControllerCreateFeatureFlag(createFeatureFlagDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a FeatureFlag
     * @param {string} id FeatureFlag ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsControllerPermanentlyDeleteFeatureFlag(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted FeatureFlag
     * @param {string} id FeatureFlag ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerRestoreFeatureFlag(id, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsControllerRestoreFeatureFlag(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft-delete a FeatureFlag by ID
     * @param {string} id FeatureFlag ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerSoftDeleteFeatureFlag(id, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsControllerSoftDeleteFeatureFlag(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing FeatureFlag (e.g., enablement)
     * @param {UpdateFeatureFlagDto} updateFeatureFlagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsControllerUpdateFeatureFlag(updateFeatureFlagDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a FeatureFlag by its ID
     * @param {any} id FeatureFlag ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsQueryControllerGetFeatureFlagById(id, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsQueryControllerGetFeatureFlagById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List FeatureFlags by enabled=true/false
     * @param {boolean} enabled
     * @param {number} [take]
     * @param {number} [skip]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsQueryControllerGetFeatureFlagsByEnabledState(enabled, take, skip, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsQueryControllerGetFeatureFlagsByEnabledState(enabled, take, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List FeatureFlags by userId, roleId, or tenantId
     * @param {number} [take]
     * @param {number} [skip]
     * @param {string} [tenantId]
     * @param {string} [roleId]
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsQueryControllerGetFeatureFlagsByEntity(take, skip, tenantId, roleId, userId, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsQueryControllerGetFeatureFlagsByEntity(take, skip, tenantId, roleId, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List FeatureFlags by featureId
     * @param {any} featureId The feature ID to filter by.
     * @param {number} [take]
     * @param {number} [skip]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsQueryControllerGetFeatureFlagsByFeature(featureId, take, skip, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsQueryControllerGetFeatureFlagsByFeature(featureId, take, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve non-deleted FeatureFlags (optional pagination)
     * @param {number} [take]
     * @param {number} [skip]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagsApi
     */
    featureFlagsQueryControllerGetNonDeletedFeatureFlags(take, skip, options) {
        return FeatureFlagsApiFp(this.configuration).featureFlagsQueryControllerGetNonDeletedFeatureFlags(take, skip, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeatureStatsApi - axios parameter creator
 * @export
 */
export const FeatureStatsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieve feature usage statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureStatsControllerGetFeatureUsageStats: async (options = {}) => {
            const localVarPath = `/api/features/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeatureStatsApi - functional programming interface
 * @export
 */
export const FeatureStatsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeatureStatsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retrieve feature usage statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureStatsControllerGetFeatureUsageStats(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureStatsControllerGetFeatureUsageStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureStatsApi.featureStatsControllerGetFeatureUsageStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeatureStatsApi - factory interface
 * @export
 */
export const FeatureStatsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeatureStatsApiFp(configuration);
    return {
        /**
         *
         * @summary Retrieve feature usage statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureStatsControllerGetFeatureUsageStats(options) {
            return localVarFp.featureStatsControllerGetFeatureUsageStats(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeatureStatsApi - object-oriented interface
 * @export
 * @class FeatureStatsApi
 * @extends {BaseAPI}
 */
export class FeatureStatsApi extends BaseAPI {
    /**
     *
     * @summary Retrieve feature usage statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureStatsApi
     */
    featureStatsControllerGetFeatureUsageStats(options) {
        return FeatureStatsApiFp(this.configuration).featureStatsControllerGetFeatureUsageStats(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeaturesApi - axios parameter creator
 * @export
 */
export const FeaturesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new feature
         * @param {CreateFeatureDto} createFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerCreateFeature: async (createFeatureDto, options = {}) => {
            // verify required parameter 'createFeatureDto' is not null or undefined
            assertParamExists('featuresControllerCreateFeature', 'createFeatureDto', createFeatureDto);
            const localVarPath = `/api/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createFeatureDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerPermanentlyDeleteFeature: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerPermanentlyDeleteFeature', 'id', id);
            const localVarPath = `/api/features/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerRestoreFeature: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerRestoreFeature', 'id', id);
            const localVarPath = `/api/features/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerSoftDeleteFeature: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerSoftDeleteFeature', 'id', id);
            const localVarPath = `/api/features/{id}/soft-delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Toggle the enabled state of a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerToggleFeatureState: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerToggleFeatureState', 'id', id);
            const localVarPath = `/api/features/{id}/toggle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing feature
         * @param {string} id Feature ID
         * @param {UpdateFeatureDto} updateFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerUpdateFeature: async (id, updateFeatureDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresControllerUpdateFeature', 'id', id);
            // verify required parameter 'updateFeatureDto' is not null or undefined
            assertParamExists('featuresControllerUpdateFeature', 'updateFeatureDto', updateFeatureDto);
            const localVarPath = `/api/features/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateFeatureDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all features with optional filters
         * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
         * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
         * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
         * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresQueryControllerGetAllFeatures: async (enabled, includeDeleted, skip, take, options = {}) => {
            const localVarPath = `/api/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a feature by ID
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresQueryControllerGetFeatureById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuresQueryControllerGetFeatureById', 'id', id);
            const localVarPath = `/api/features/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve multiple features by IDs
         * @param {Array<string>} ids List of feature IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresQueryControllerListFeaturesByIds: async (ids, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('featuresQueryControllerListFeaturesByIds', 'ids', ids);
            const localVarPath = `/api/features/list-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeaturesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new feature
         * @param {CreateFeatureDto} createFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerCreateFeature(createFeatureDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerCreateFeature(createFeatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerCreateFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerPermanentlyDeleteFeature(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerPermanentlyDeleteFeature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerPermanentlyDeleteFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerRestoreFeature(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerRestoreFeature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerRestoreFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerSoftDeleteFeature(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerSoftDeleteFeature(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerSoftDeleteFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Toggle the enabled state of a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerToggleFeatureState(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerToggleFeatureState(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerToggleFeatureState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing feature
         * @param {string} id Feature ID
         * @param {UpdateFeatureDto} updateFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresControllerUpdateFeature(id, updateFeatureDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresControllerUpdateFeature(id, updateFeatureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresControllerUpdateFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all features with optional filters
         * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
         * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
         * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
         * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresQueryControllerGetAllFeatures(enabled, includeDeleted, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresQueryControllerGetAllFeatures(enabled, includeDeleted, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresQueryControllerGetAllFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a feature by ID
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresQueryControllerGetFeatureById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresQueryControllerGetFeatureById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresQueryControllerGetFeatureById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve multiple features by IDs
         * @param {Array<string>} ids List of feature IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresQueryControllerListFeaturesByIds(ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresQueryControllerListFeaturesByIds(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesApi.featuresQueryControllerListFeaturesByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeaturesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new feature
         * @param {CreateFeatureDto} createFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerCreateFeature(createFeatureDto, options) {
            return localVarFp.featuresControllerCreateFeature(createFeatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerPermanentlyDeleteFeature(id, options) {
            return localVarFp.featuresControllerPermanentlyDeleteFeature(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerRestoreFeature(id, options) {
            return localVarFp.featuresControllerRestoreFeature(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerSoftDeleteFeature(id, options) {
            return localVarFp.featuresControllerSoftDeleteFeature(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Toggle the enabled state of a feature
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerToggleFeatureState(id, options) {
            return localVarFp.featuresControllerToggleFeatureState(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing feature
         * @param {string} id Feature ID
         * @param {UpdateFeatureDto} updateFeatureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresControllerUpdateFeature(id, updateFeatureDto, options) {
            return localVarFp.featuresControllerUpdateFeature(id, updateFeatureDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all features with optional filters
         * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
         * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
         * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
         * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresQueryControllerGetAllFeatures(enabled, includeDeleted, skip, take, options) {
            return localVarFp.featuresQueryControllerGetAllFeatures(enabled, includeDeleted, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a feature by ID
         * @param {string} id Feature ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresQueryControllerGetFeatureById(id, options) {
            return localVarFp.featuresQueryControllerGetFeatureById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve multiple features by IDs
         * @param {Array<string>} ids List of feature IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresQueryControllerListFeaturesByIds(ids, options) {
            return localVarFp.featuresQueryControllerListFeaturesByIds(ids, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
    /**
     *
     * @summary Create a new feature
     * @param {CreateFeatureDto} createFeatureDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerCreateFeature(createFeatureDto, options) {
        return FeaturesApiFp(this.configuration).featuresControllerCreateFeature(createFeatureDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerPermanentlyDeleteFeature(id, options) {
        return FeaturesApiFp(this.configuration).featuresControllerPermanentlyDeleteFeature(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerRestoreFeature(id, options) {
        return FeaturesApiFp(this.configuration).featuresControllerRestoreFeature(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerSoftDeleteFeature(id, options) {
        return FeaturesApiFp(this.configuration).featuresControllerSoftDeleteFeature(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Toggle the enabled state of a feature
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerToggleFeatureState(id, options) {
        return FeaturesApiFp(this.configuration).featuresControllerToggleFeatureState(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing feature
     * @param {string} id Feature ID
     * @param {UpdateFeatureDto} updateFeatureDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresControllerUpdateFeature(id, updateFeatureDto, options) {
        return FeaturesApiFp(this.configuration).featuresControllerUpdateFeature(id, updateFeatureDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all features with optional filters
     * @param {boolean} [enabled] Filter by enabled features only. Defaults to \&quot;undefined\&quot; (no filtering).
     * @param {boolean} [includeDeleted] If set to true, also include deleted features in the result set.
     * @param {number} [skip] Number of records to skip (pagination). Defaults to 0 if not provided.
     * @param {number} [take] Number of records to take (pagination). Defaults to 10 if not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresQueryControllerGetAllFeatures(enabled, includeDeleted, skip, take, options) {
        return FeaturesApiFp(this.configuration).featuresQueryControllerGetAllFeatures(enabled, includeDeleted, skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a feature by ID
     * @param {string} id Feature ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresQueryControllerGetFeatureById(id, options) {
        return FeaturesApiFp(this.configuration).featuresQueryControllerGetFeatureById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve multiple features by IDs
     * @param {Array<string>} ids List of feature IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesApi
     */
    featuresQueryControllerListFeaturesByIds(ids, options) {
        return FeaturesApiFp(this.configuration).featuresQueryControllerListFeaturesByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck: async (options = {}) => {
            const localVarPath = `/api/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerLive: async (options = {}) => {
            const localVarPath = `/api/health/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerReady: async (options = {}) => {
            const localVarPath = `/api/health/ready`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function (configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerCheck(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerLive(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerLive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerReady(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerReady(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerReady']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HealthApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck(options) {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerLive(options) {
            return localVarFp.healthControllerLive(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerReady(options) {
            return localVarFp.healthControllerReady(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerCheck(options) {
        return HealthApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerLive(options) {
        return HealthApiFp(this.configuration).healthControllerLive(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    healthControllerReady(options) {
        return HealthApiFp(this.configuration).healthControllerReady(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InvitationsApi - axios parameter creator
 * @export
 */
export const InvitationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new invitation record
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerCreateInvitation: async (createInvitationDto, options = {}) => {
            // verify required parameter 'createInvitationDto' is not null or undefined
            assertParamExists('invitationsControllerCreateInvitation', 'createInvitationDto', createInvitationDto);
            const localVarPath = `/api/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve an invitation by ID
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerGetInvitationById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsControllerGetInvitationById', 'id', id);
            const localVarPath = `/api/invitations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List invitations with optional pagination
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerListInvitations: async (skip, take, options = {}) => {
            const localVarPath = `/api/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel an invitation (mark it as declined by admin)
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerMarkInvitationAsCanceled: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsControllerMarkInvitationAsCanceled', 'id', id);
            const localVarPath = `/api/invitations/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mark an invitation as declined
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerMarkInvitationAsDeclined: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsControllerMarkInvitationAsDeclined', 'id', id);
            const localVarPath = `/api/invitations/{id}/mark-declined`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mark an invitation as used
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerMarkInvitationAsUsed: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsControllerMarkInvitationAsUsed', 'id', id);
            const localVarPath = `/api/invitations/{id}/mark-used`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a soft-deleted invitation
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerPermanentlyDeleteInvitation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsControllerPermanentlyDeleteInvitation', 'id', id);
            const localVarPath = `/api/invitations/{id}/permanent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Resend an invitation (side-effect only)
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerResendInvitation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsControllerResendInvitation', 'id', id);
            const localVarPath = `/api/invitations/{id}/resend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InvitationsApi - functional programming interface
 * @export
 */
export const InvitationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = InvitationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new invitation record
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerCreateInvitation(createInvitationDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerCreateInvitation(createInvitationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerCreateInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve an invitation by ID
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerGetInvitationById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerGetInvitationById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerGetInvitationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List invitations with optional pagination
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerListInvitations(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerListInvitations(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerListInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Cancel an invitation (mark it as declined by admin)
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerMarkInvitationAsCanceled(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerMarkInvitationAsCanceled(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerMarkInvitationAsCanceled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Mark an invitation as declined
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerMarkInvitationAsDeclined(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerMarkInvitationAsDeclined(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerMarkInvitationAsDeclined']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Mark an invitation as used
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerMarkInvitationAsUsed(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerMarkInvitationAsUsed(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerMarkInvitationAsUsed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a soft-deleted invitation
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerPermanentlyDeleteInvitation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerPermanentlyDeleteInvitation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerPermanentlyDeleteInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Resend an invitation (side-effect only)
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsControllerResendInvitation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerResendInvitation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitationsApi.invitationsControllerResendInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * InvitationsApi - factory interface
 * @export
 */
export const InvitationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InvitationsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new invitation record
         * @param {CreateInvitationDto} createInvitationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerCreateInvitation(createInvitationDto, options) {
            return localVarFp.invitationsControllerCreateInvitation(createInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve an invitation by ID
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerGetInvitationById(id, options) {
            return localVarFp.invitationsControllerGetInvitationById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List invitations with optional pagination
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerListInvitations(skip, take, options) {
            return localVarFp.invitationsControllerListInvitations(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel an invitation (mark it as declined by admin)
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerMarkInvitationAsCanceled(id, options) {
            return localVarFp.invitationsControllerMarkInvitationAsCanceled(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark an invitation as declined
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerMarkInvitationAsDeclined(id, options) {
            return localVarFp.invitationsControllerMarkInvitationAsDeclined(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark an invitation as used
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerMarkInvitationAsUsed(id, options) {
            return localVarFp.invitationsControllerMarkInvitationAsUsed(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a soft-deleted invitation
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerPermanentlyDeleteInvitation(id, options) {
            return localVarFp.invitationsControllerPermanentlyDeleteInvitation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resend an invitation (side-effect only)
         * @param {string} id Invitation ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsControllerResendInvitation(id, options) {
            return localVarFp.invitationsControllerResendInvitation(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InvitationsApi - object-oriented interface
 * @export
 * @class InvitationsApi
 * @extends {BaseAPI}
 */
export class InvitationsApi extends BaseAPI {
    /**
     *
     * @summary Create a new invitation record
     * @param {CreateInvitationDto} createInvitationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerCreateInvitation(createInvitationDto, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerCreateInvitation(createInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve an invitation by ID
     * @param {string} id Invitation ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerGetInvitationById(id, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerGetInvitationById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List invitations with optional pagination
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerListInvitations(skip, take, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerListInvitations(skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel an invitation (mark it as declined by admin)
     * @param {string} id Invitation ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerMarkInvitationAsCanceled(id, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerMarkInvitationAsCanceled(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark an invitation as declined
     * @param {string} id Invitation ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerMarkInvitationAsDeclined(id, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerMarkInvitationAsDeclined(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark an invitation as used
     * @param {string} id Invitation ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerMarkInvitationAsUsed(id, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerMarkInvitationAsUsed(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a soft-deleted invitation
     * @param {string} id Invitation ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerPermanentlyDeleteInvitation(id, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerPermanentlyDeleteInvitation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resend an invitation (side-effect only)
     * @param {string} id Invitation ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    invitationsControllerResendInvitation(id, options) {
        return InvitationsApiFp(this.configuration).invitationsControllerResendInvitation(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LoginAttemptsApi - axios parameter creator
 * @export
 */
export const LoginAttemptsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Bulk create multiple login attempts in one request.
         * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateBulkLoginAttempts: async (bulkCreateLoginAttemptsDto, options = {}) => {
            // verify required parameter 'bulkCreateLoginAttemptsDto' is not null or undefined
            assertParamExists('loginAttemptsControllerCreateBulkLoginAttempts', 'bulkCreateLoginAttemptsDto', bulkCreateLoginAttemptsDto);
            const localVarPath = `/api/login-attempts/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateLoginAttemptsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new login attempt record.
         * @param {CreateLoginAttemptDto} createLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateLoginAttempt: async (createLoginAttemptDto, options = {}) => {
            // verify required parameter 'createLoginAttemptDto' is not null or undefined
            assertParamExists('loginAttemptsControllerCreateLoginAttempt', 'createLoginAttemptDto', createLoginAttemptDto);
            const localVarPath = `/api/login-attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createLoginAttemptDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete all login attempts older than a certain date/time.
         * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerDeleteOldLoginAttempts: async (deleteOldLoginAttemptsDto, options = {}) => {
            // verify required parameter 'deleteOldLoginAttemptsDto' is not null or undefined
            assertParamExists('loginAttemptsControllerDeleteOldLoginAttempts', 'deleteOldLoginAttemptsDto', deleteOldLoginAttemptsDto);
            const localVarPath = `/api/login-attempts/delete-old`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOldLoginAttemptsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a login attempt by its ID.
         * @param {string} id LoginAttempt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttemptById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loginAttemptsControllerGetLoginAttemptById', 'id', id);
            const localVarPath = `/api/login-attempts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve multiple login attempts with optional filters.
         * @param {number} [skip] Number of records to skip.
         * @param {number} [take] Number of records to take.
         * @param {string} [userId] Filter by userId.
         * @param {string} [tenantId] Filter by tenantId.
         * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
         * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttempts: async (skip, take, userId, tenantId, success, fromDate, toDate, options = {}) => {
            const localVarPath = `/api/login-attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (success !== undefined) {
                localVarQueryParameter['success'] = success;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a login attempt.
         * @param {string} id The ID of the login attempt to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerPermanentlyDeleteLoginAttempt: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loginAttemptsControllerPermanentlyDeleteLoginAttempt', 'id', id);
            const localVarPath = `/api/login-attempts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing login attempt record.
         * @param {string} id The ID of the login attempt to update.
         * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerUpdateLoginAttempt: async (id, updateLoginAttemptDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('loginAttemptsControllerUpdateLoginAttempt', 'id', id);
            // verify required parameter 'updateLoginAttemptDto' is not null or undefined
            assertParamExists('loginAttemptsControllerUpdateLoginAttempt', 'updateLoginAttemptDto', updateLoginAttemptDto);
            const localVarPath = `/api/login-attempts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoginAttemptDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LoginAttemptsApi - functional programming interface
 * @export
 */
export const LoginAttemptsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LoginAttemptsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Bulk create multiple login attempts in one request.
         * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerCreateBulkLoginAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new login attempt record.
         * @param {CreateLoginAttemptDto} createLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerCreateLoginAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete all login attempts older than a certain date/time.
         * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerDeleteOldLoginAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a login attempt by its ID.
         * @param {string} id LoginAttempt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerGetLoginAttemptById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerGetLoginAttemptById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerGetLoginAttemptById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve multiple login attempts with optional filters.
         * @param {number} [skip] Number of records to skip.
         * @param {number} [take] Number of records to take.
         * @param {string} [userId] Filter by userId.
         * @param {string} [tenantId] Filter by tenantId.
         * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
         * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerGetLoginAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a login attempt.
         * @param {string} id The ID of the login attempt to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerPermanentlyDeleteLoginAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing login attempt record.
         * @param {string} id The ID of the login attempt to update.
         * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoginAttemptsApi.loginAttemptsControllerUpdateLoginAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LoginAttemptsApi - factory interface
 * @export
 */
export const LoginAttemptsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LoginAttemptsApiFp(configuration);
    return {
        /**
         *
         * @summary Bulk create multiple login attempts in one request.
         * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options) {
            return localVarFp.loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new login attempt record.
         * @param {CreateLoginAttemptDto} createLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options) {
            return localVarFp.loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete all login attempts older than a certain date/time.
         * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options) {
            return localVarFp.loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a login attempt by its ID.
         * @param {string} id LoginAttempt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttemptById(id, options) {
            return localVarFp.loginAttemptsControllerGetLoginAttemptById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve multiple login attempts with optional filters.
         * @param {number} [skip] Number of records to skip.
         * @param {number} [take] Number of records to take.
         * @param {string} [userId] Filter by userId.
         * @param {string} [tenantId] Filter by tenantId.
         * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
         * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options) {
            return localVarFp.loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a login attempt.
         * @param {string} id The ID of the login attempt to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options) {
            return localVarFp.loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing login attempt record.
         * @param {string} id The ID of the login attempt to update.
         * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options) {
            return localVarFp.loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LoginAttemptsApi - object-oriented interface
 * @export
 * @class LoginAttemptsApi
 * @extends {BaseAPI}
 */
export class LoginAttemptsApi extends BaseAPI {
    /**
     *
     * @summary Bulk create multiple login attempts in one request.
     * @param {BulkCreateLoginAttemptsDto} bulkCreateLoginAttemptsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerCreateBulkLoginAttempts(bulkCreateLoginAttemptsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new login attempt record.
     * @param {CreateLoginAttemptDto} createLoginAttemptDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerCreateLoginAttempt(createLoginAttemptDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete all login attempts older than a certain date/time.
     * @param {DeleteOldLoginAttemptsDto} deleteOldLoginAttemptsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerDeleteOldLoginAttempts(deleteOldLoginAttemptsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a login attempt by its ID.
     * @param {string} id LoginAttempt ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerGetLoginAttemptById(id, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerGetLoginAttemptById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve multiple login attempts with optional filters.
     * @param {number} [skip] Number of records to skip.
     * @param {number} [take] Number of records to take.
     * @param {string} [userId] Filter by userId.
     * @param {string} [tenantId] Filter by tenantId.
     * @param {boolean} [success] Filter by success status (true&#x3D;successful, false&#x3D;failed).
     * @param {string} [fromDate] Minimum date/time (ISO 8601) for the login attempt timestamp filter.
     * @param {string} [toDate] Maximum date/time (ISO 8601) for the login attempt timestamp filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerGetLoginAttempts(skip, take, userId, tenantId, success, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a login attempt.
     * @param {string} id The ID of the login attempt to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerPermanentlyDeleteLoginAttempt(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing login attempt record.
     * @param {string} id The ID of the login attempt to update.
     * @param {UpdateLoginAttemptDto} updateLoginAttemptDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginAttemptsApi
     */
    loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options) {
        return LoginAttemptsApiFp(this.configuration).loginAttemptsControllerUpdateLoginAttempt(id, updateLoginAttemptDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MFAManagementApi - axios parameter creator
 * @export
 */
export const MFAManagementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Soft-deletes unverified MFA records for a user. Use this to fix \"MFA already exists\" errors when registration was started but never completed.
         * @summary Clean up unverified MFA records
         * @param {MfaCleanupDto} mfaCleanupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerCleanupUnverifiedMfa: async (mfaCleanupDto, options = {}) => {
            // verify required parameter 'mfaCleanupDto' is not null or undefined
            assertParamExists('mfaControllerCleanupUnverifiedMfa', 'mfaCleanupDto', mfaCleanupDto);
            const localVarPath = `/api/mfa/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(mfaCleanupDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all MFA records including unverified and soft-deleted records for debugging purposes.
         * @summary List all MFA records for a user
         * @param {string} userId User UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerListMfaRecords: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('mfaControllerListMfaRecords', 'userId', userId);
            const localVarPath = `/api/mfa/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Completely resets MFA for a user: soft-deletes ALL MFA records and sets mfaEnabled to false. Use with caution.
         * @summary Full MFA reset for a user
         * @param {MfaResetDto} mfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerResetMfa: async (mfaResetDto, options = {}) => {
            // verify required parameter 'mfaResetDto' is not null or undefined
            assertParamExists('mfaControllerResetMfa', 'mfaResetDto', mfaResetDto);
            const localVarPath = `/api/mfa/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(mfaResetDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * MFAManagementApi - functional programming interface
 * @export
 */
export const MFAManagementApiFp = function (configuration) {
    const localVarAxiosParamCreator = MFAManagementApiAxiosParamCreator(configuration);
    return {
        /**
         * Soft-deletes unverified MFA records for a user. Use this to fix \"MFA already exists\" errors when registration was started but never completed.
         * @summary Clean up unverified MFA records
         * @param {MfaCleanupDto} mfaCleanupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerCleanupUnverifiedMfa(mfaCleanupDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerCleanupUnverifiedMfa(mfaCleanupDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAManagementApi.mfaControllerCleanupUnverifiedMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all MFA records including unverified and soft-deleted records for debugging purposes.
         * @summary List all MFA records for a user
         * @param {string} userId User UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerListMfaRecords(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerListMfaRecords(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAManagementApi.mfaControllerListMfaRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Completely resets MFA for a user: soft-deletes ALL MFA records and sets mfaEnabled to false. Use with caution.
         * @summary Full MFA reset for a user
         * @param {MfaResetDto} mfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mfaControllerResetMfa(mfaResetDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mfaControllerResetMfa(mfaResetDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MFAManagementApi.mfaControllerResetMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * MFAManagementApi - factory interface
 * @export
 */
export const MFAManagementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MFAManagementApiFp(configuration);
    return {
        /**
         * Soft-deletes unverified MFA records for a user. Use this to fix \"MFA already exists\" errors when registration was started but never completed.
         * @summary Clean up unverified MFA records
         * @param {MfaCleanupDto} mfaCleanupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerCleanupUnverifiedMfa(mfaCleanupDto, options) {
            return localVarFp.mfaControllerCleanupUnverifiedMfa(mfaCleanupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all MFA records including unverified and soft-deleted records for debugging purposes.
         * @summary List all MFA records for a user
         * @param {string} userId User UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerListMfaRecords(userId, options) {
            return localVarFp.mfaControllerListMfaRecords(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Completely resets MFA for a user: soft-deletes ALL MFA records and sets mfaEnabled to false. Use with caution.
         * @summary Full MFA reset for a user
         * @param {MfaResetDto} mfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mfaControllerResetMfa(mfaResetDto, options) {
            return localVarFp.mfaControllerResetMfa(mfaResetDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MFAManagementApi - object-oriented interface
 * @export
 * @class MFAManagementApi
 * @extends {BaseAPI}
 */
export class MFAManagementApi extends BaseAPI {
    /**
     * Soft-deletes unverified MFA records for a user. Use this to fix \"MFA already exists\" errors when registration was started but never completed.
     * @summary Clean up unverified MFA records
     * @param {MfaCleanupDto} mfaCleanupDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAManagementApi
     */
    mfaControllerCleanupUnverifiedMfa(mfaCleanupDto, options) {
        return MFAManagementApiFp(this.configuration).mfaControllerCleanupUnverifiedMfa(mfaCleanupDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all MFA records including unverified and soft-deleted records for debugging purposes.
     * @summary List all MFA records for a user
     * @param {string} userId User UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAManagementApi
     */
    mfaControllerListMfaRecords(userId, options) {
        return MFAManagementApiFp(this.configuration).mfaControllerListMfaRecords(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Completely resets MFA for a user: soft-deletes ALL MFA records and sets mfaEnabled to false. Use with caution.
     * @summary Full MFA reset for a user
     * @param {MfaResetDto} mfaResetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MFAManagementApi
     */
    mfaControllerResetMfa(mfaResetDto, options) {
        return MFAManagementApiFp(this.configuration).mfaControllerResetMfa(mfaResetDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionAssignmentsApi - axios parameter creator
 * @export
 */
export const PermissionAssignmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new PermissionAssignment record
         * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerCreateAssignment: async (createPermissionAssignmentDto, options = {}) => {
            // verify required parameter 'createPermissionAssignmentDto' is not null or undefined
            assertParamExists('permissionAssignmentsControllerCreateAssignment', 'createPermissionAssignmentDto', createPermissionAssignmentDto);
            const localVarPath = `/api/permission-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionAssignmentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a PermissionAssignment by its ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerDeleteAssignment: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionAssignmentsControllerDeleteAssignment', 'id', id);
            const localVarPath = `/api/permission-assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a PermissionAssignment by its unique ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerGetAssignmentById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionAssignmentsControllerGetAssignmentById', 'id', id);
            const localVarPath = `/api/permission-assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List PermissionAssignments with optional filters/pagination
         * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
         * @param {string} [subjectId] Filter by subjectId (UUID)
         * @param {string} [permissionId] Filter by permissionId (UUID)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerListAssignments: async (subjectType, subjectId, permissionId, skip, take, options = {}) => {
            const localVarPath = `/api/permission-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (subjectType !== undefined) {
                localVarQueryParameter['subjectType'] = subjectType;
            }
            if (subjectId !== undefined) {
                localVarQueryParameter['subjectId'] = subjectId;
            }
            if (permissionId !== undefined) {
                localVarQueryParameter['permissionId'] = permissionId;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerUpdateAssignment: async (id, updatePermissionAssignmentDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionAssignmentsControllerUpdateAssignment', 'id', id);
            // verify required parameter 'updatePermissionAssignmentDto' is not null or undefined
            assertParamExists('permissionAssignmentsControllerUpdateAssignment', 'updatePermissionAssignmentDto', updatePermissionAssignmentDto);
            const localVarPath = `/api/permission-assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePermissionAssignmentDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PermissionAssignmentsApi - functional programming interface
 * @export
 */
export const PermissionAssignmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionAssignmentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new PermissionAssignment record
         * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerCreateAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a PermissionAssignment by its ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerDeleteAssignment(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerDeleteAssignment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerDeleteAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a PermissionAssignment by its unique ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerGetAssignmentById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerGetAssignmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerGetAssignmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List PermissionAssignments with optional filters/pagination
         * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
         * @param {string} [subjectId] Filter by subjectId (UUID)
         * @param {string} [permissionId] Filter by permissionId (UUID)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerListAssignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionAssignmentsApi.permissionAssignmentsControllerUpdateAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PermissionAssignmentsApi - factory interface
 * @export
 */
export const PermissionAssignmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionAssignmentsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new PermissionAssignment record
         * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options) {
            return localVarFp.permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a PermissionAssignment by its ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerDeleteAssignment(id, options) {
            return localVarFp.permissionAssignmentsControllerDeleteAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a PermissionAssignment by its unique ID
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerGetAssignmentById(id, options) {
            return localVarFp.permissionAssignmentsControllerGetAssignmentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List PermissionAssignments with optional filters/pagination
         * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
         * @param {string} [subjectId] Filter by subjectId (UUID)
         * @param {string} [permissionId] Filter by permissionId (UUID)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options) {
            return localVarFp.permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
         * @param {string} id PermissionAssignment ID (UUID)
         * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options) {
            return localVarFp.permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionAssignmentsApi - object-oriented interface
 * @export
 * @class PermissionAssignmentsApi
 * @extends {BaseAPI}
 */
export class PermissionAssignmentsApi extends BaseAPI {
    /**
     *
     * @summary Create a new PermissionAssignment record
     * @param {CreatePermissionAssignmentDto} createPermissionAssignmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options) {
        return PermissionAssignmentsApiFp(this.configuration).permissionAssignmentsControllerCreateAssignment(createPermissionAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a PermissionAssignment by its ID
     * @param {string} id PermissionAssignment ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerDeleteAssignment(id, options) {
        return PermissionAssignmentsApiFp(this.configuration).permissionAssignmentsControllerDeleteAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a PermissionAssignment by its unique ID
     * @param {string} id PermissionAssignment ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerGetAssignmentById(id, options) {
        return PermissionAssignmentsApiFp(this.configuration).permissionAssignmentsControllerGetAssignmentById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List PermissionAssignments with optional filters/pagination
     * @param {string} [subjectType] Filter by subjectType (USER, ROLE, etc.)
     * @param {string} [subjectId] Filter by subjectId (UUID)
     * @param {string} [permissionId] Filter by permissionId (UUID)
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options) {
        return PermissionAssignmentsApiFp(this.configuration).permissionAssignmentsControllerListAssignments(subjectType, subjectId, permissionId, skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing PermissionAssignment record (e.g., expiresAt)
     * @param {string} id PermissionAssignment ID (UUID)
     * @param {UpdatePermissionAssignmentDto} updatePermissionAssignmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionAssignmentsApi
     */
    permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options) {
        return PermissionAssignmentsApiFp(this.configuration).permissionAssignmentsControllerUpdateAssignment(id, updatePermissionAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new Permission record
         * @param {CreatePermissionDto} createPermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerCreatePermission: async (createPermissionDto, options = {}) => {
            // verify required parameter 'createPermissionDto' is not null or undefined
            assertParamExists('permissionsControllerCreatePermission', 'createPermissionDto', createPermissionDto);
            const localVarPath = `/api/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a Permission by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerDeletePermission: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionsControllerDeletePermission', 'id', id);
            const localVarPath = `/api/permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a Permission record by its featureId
         * @param {string} featureId Feature ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionByFeatureId: async (featureId, options = {}) => {
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('permissionsControllerGetPermissionByFeatureId', 'featureId', featureId);
            const localVarPath = `/api/permissions/by-feature/{featureId}`
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a Permission record by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionsControllerGetPermissionById', 'id', id);
            const localVarPath = `/api/permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List multiple Permission records, optionally filtered/paginated
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {string} [featureId] Optionally filter by featureId (UUID).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerListPermissions: async (skip, take, featureId, options = {}) => {
            const localVarPath = `/api/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (featureId !== undefined) {
                localVarQueryParameter['featureId'] = featureId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing Permission record
         * @param {string} id Permission ID (UUID)
         * @param {UpdatePermissionDto} updatePermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerUpdatePermission: async (id, updatePermissionDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('permissionsControllerUpdatePermission', 'id', id);
            // verify required parameter 'updatePermissionDto' is not null or undefined
            assertParamExists('permissionsControllerUpdatePermission', 'updatePermissionDto', updatePermissionDto);
            const localVarPath = `/api/permissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updatePermissionDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new Permission record
         * @param {CreatePermissionDto} createPermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerCreatePermission(createPermissionDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerCreatePermission(createPermissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerCreatePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a Permission by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerDeletePermission(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerDeletePermission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerDeletePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a Permission record by its featureId
         * @param {string} featureId Feature ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerGetPermissionByFeatureId(featureId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerGetPermissionByFeatureId(featureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerGetPermissionByFeatureId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a Permission record by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerGetPermissionById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerGetPermissionById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerGetPermissionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List multiple Permission records, optionally filtered/paginated
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {string} [featureId] Optionally filter by featureId (UUID).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerListPermissions(skip, take, featureId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerListPermissions(skip, take, featureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerListPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing Permission record
         * @param {string} id Permission ID (UUID)
         * @param {UpdatePermissionDto} updatePermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsControllerUpdatePermission(id, updatePermissionDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsControllerUpdatePermission(id, updatePermissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.permissionsControllerUpdatePermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new Permission record
         * @param {CreatePermissionDto} createPermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerCreatePermission(createPermissionDto, options) {
            return localVarFp.permissionsControllerCreatePermission(createPermissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a Permission by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerDeletePermission(id, options) {
            return localVarFp.permissionsControllerDeletePermission(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a Permission record by its featureId
         * @param {string} featureId Feature ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionByFeatureId(featureId, options) {
            return localVarFp.permissionsControllerGetPermissionByFeatureId(featureId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a Permission record by its ID
         * @param {string} id Permission ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerGetPermissionById(id, options) {
            return localVarFp.permissionsControllerGetPermissionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List multiple Permission records, optionally filtered/paginated
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {string} [featureId] Optionally filter by featureId (UUID).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerListPermissions(skip, take, featureId, options) {
            return localVarFp.permissionsControllerListPermissions(skip, take, featureId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing Permission record
         * @param {string} id Permission ID (UUID)
         * @param {UpdatePermissionDto} updatePermissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsControllerUpdatePermission(id, updatePermissionDto, options) {
            return localVarFp.permissionsControllerUpdatePermission(id, updatePermissionDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     *
     * @summary Create a new Permission record
     * @param {CreatePermissionDto} createPermissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerCreatePermission(createPermissionDto, options) {
        return PermissionsApiFp(this.configuration).permissionsControllerCreatePermission(createPermissionDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a Permission by its ID
     * @param {string} id Permission ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerDeletePermission(id, options) {
        return PermissionsApiFp(this.configuration).permissionsControllerDeletePermission(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a Permission record by its featureId
     * @param {string} featureId Feature ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerGetPermissionByFeatureId(featureId, options) {
        return PermissionsApiFp(this.configuration).permissionsControllerGetPermissionByFeatureId(featureId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a Permission record by its ID
     * @param {string} id Permission ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerGetPermissionById(id, options) {
        return PermissionsApiFp(this.configuration).permissionsControllerGetPermissionById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List multiple Permission records, optionally filtered/paginated
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {string} [featureId] Optionally filter by featureId (UUID).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerListPermissions(skip, take, featureId, options) {
        return PermissionsApiFp(this.configuration).permissionsControllerListPermissions(skip, take, featureId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing Permission record
     * @param {string} id Permission ID (UUID)
     * @param {UpdatePermissionDto} updatePermissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsControllerUpdatePermission(id, updatePermissionDto, options) {
        return PermissionsApiFp(this.configuration).permissionsControllerUpdatePermission(id, updatePermissionDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingControllerPing: async (options = {}) => {
            const localVarPath = `/api/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function (configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pingControllerPing(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pingControllerPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingApi.pingControllerPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PingApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingControllerPing(options) {
            return localVarFp.pingControllerPing(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    pingControllerPing(options) {
        return PingApiFp(this.configuration).pingControllerPing(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new role
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerCreateRole: async (createRoleDto, options = {}) => {
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('rolesControllerCreateRole', 'createRoleDto', createRoleDto);
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all roles with optional pagination
         * @param {number} [skip] Records to skip (pagination). Default 0.
         * @param {number} [take] Records to take (max 50). Default 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerFindAllRoles: async (skip, take, options = {}) => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a role by ID
         * @param {string} id The ID of the role to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerFindRoleById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerFindRoleById', 'id', id);
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a role
         * @param {string} id The ID of the role to delete permanently
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerPermanentlyDeleteRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerPermanentlyDeleteRole', 'id', id);
            const localVarPath = `/api/roles/{id}/permanent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted role
         * @param {string} id The ID of the role to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerRestoreRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerRestoreRole', 'id', id);
            const localVarPath = `/api/roles/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a role
         * @param {string} id The ID of the role to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerSoftDeleteRole: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerSoftDeleteRole', 'id', id);
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a role\'s details
         * @param {string} id The ID of the role to update
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerUpdateRole: async (id, updateRoleDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerUpdateRole', 'id', id);
            // verify required parameter 'updateRoleDto' is not null or undefined
            assertParamExists('rolesControllerUpdateRole', 'updateRoleDto', updateRoleDto);
            const localVarPath = `/api/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new role
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerCreateRole(createRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerCreateRole(createRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerCreateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all roles with optional pagination
         * @param {number} [skip] Records to skip (pagination). Default 0.
         * @param {number} [take] Records to take (max 50). Default 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerFindAllRoles(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerFindAllRoles(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerFindAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a role by ID
         * @param {string} id The ID of the role to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerFindRoleById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerFindRoleById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerFindRoleById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a role
         * @param {string} id The ID of the role to delete permanently
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerPermanentlyDeleteRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerPermanentlyDeleteRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerPermanentlyDeleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted role
         * @param {string} id The ID of the role to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerRestoreRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerRestoreRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerRestoreRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a role
         * @param {string} id The ID of the role to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerSoftDeleteRole(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerSoftDeleteRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerSoftDeleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a role\'s details
         * @param {string} id The ID of the role to update
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerUpdateRole(id, updateRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerUpdateRole(id, updateRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerUpdateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RolesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new role
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerCreateRole(createRoleDto, options) {
            return localVarFp.rolesControllerCreateRole(createRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all roles with optional pagination
         * @param {number} [skip] Records to skip (pagination). Default 0.
         * @param {number} [take] Records to take (max 50). Default 10.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerFindAllRoles(skip, take, options) {
            return localVarFp.rolesControllerFindAllRoles(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a role by ID
         * @param {string} id The ID of the role to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerFindRoleById(id, options) {
            return localVarFp.rolesControllerFindRoleById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a role
         * @param {string} id The ID of the role to delete permanently
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerPermanentlyDeleteRole(id, options) {
            return localVarFp.rolesControllerPermanentlyDeleteRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted role
         * @param {string} id The ID of the role to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerRestoreRole(id, options) {
            return localVarFp.rolesControllerRestoreRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a role
         * @param {string} id The ID of the role to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerSoftDeleteRole(id, options) {
            return localVarFp.rolesControllerSoftDeleteRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a role\'s details
         * @param {string} id The ID of the role to update
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerUpdateRole(id, updateRoleDto, options) {
            return localVarFp.rolesControllerUpdateRole(id, updateRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     *
     * @summary Create a new role
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerCreateRole(createRoleDto, options) {
        return RolesApiFp(this.configuration).rolesControllerCreateRole(createRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all roles with optional pagination
     * @param {number} [skip] Records to skip (pagination). Default 0.
     * @param {number} [take] Records to take (max 50). Default 10.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerFindAllRoles(skip, take, options) {
        return RolesApiFp(this.configuration).rolesControllerFindAllRoles(skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a role by ID
     * @param {string} id The ID of the role to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerFindRoleById(id, options) {
        return RolesApiFp(this.configuration).rolesControllerFindRoleById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a role
     * @param {string} id The ID of the role to delete permanently
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerPermanentlyDeleteRole(id, options) {
        return RolesApiFp(this.configuration).rolesControllerPermanentlyDeleteRole(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted role
     * @param {string} id The ID of the role to restore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerRestoreRole(id, options) {
        return RolesApiFp(this.configuration).rolesControllerRestoreRole(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a role
     * @param {string} id The ID of the role to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerSoftDeleteRole(id, options) {
        return RolesApiFp(this.configuration).rolesControllerSoftDeleteRole(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a role\'s details
     * @param {string} id The ID of the role to update
     * @param {UpdateRoleDto} updateRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesControllerUpdateRole(id, updateRoleDto, options) {
        return RolesApiFp(this.configuration).rolesControllerUpdateRole(id, updateRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieve all sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetAllSessionsByUserId: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sessionsControllerGetAllSessionsByUserId', 'userId', userId);
            const localVarPath = `/api/sessions/all/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a session by its unique ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionById: async (sessionId, options = {}) => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionById', 'sessionId', sessionId);
            const localVarPath = `/api/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a session by its unique token (JTI)
         * @param {string} token The session token (JTI).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionByToken: async (token, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('sessionsControllerGetSessionByToken', 'token', token);
            const localVarPath = `/api/sessions/token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all active sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionsByUserId: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionsByUserId', 'userId', userId);
            const localVarPath = `/api/sessions/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke a session by its token.
         * @param {string} token The session token to revoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerRevokeSession: async (token, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('sessionsControllerRevokeSession', 'token', token);
            const localVarPath = `/api/sessions/revoke/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a session by its ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerSoftDeleteSession: async (sessionId, options = {}) => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerSoftDeleteSession', 'sessionId', sessionId);
            const localVarPath = `/api/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retrieve all sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetAllSessionsByUserId(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetAllSessionsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetAllSessionsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a session by its unique ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionById(sessionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionById(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetSessionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a session by its unique token (JTI)
         * @param {string} token The session token (JTI).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionByToken(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionByToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetSessionByToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all active sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionsByUserId(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerGetSessionsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Revoke a session by its token.
         * @param {string} token The session token to revoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerRevokeSession(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerRevokeSession(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerRevokeSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a session by its ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerSoftDeleteSession(sessionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerSoftDeleteSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SessionsApi.sessionsControllerSoftDeleteSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SessionsApiFp(configuration);
    return {
        /**
         *
         * @summary Retrieve all sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetAllSessionsByUserId(userId, options) {
            return localVarFp.sessionsControllerGetAllSessionsByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a session by its unique ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionById(sessionId, options) {
            return localVarFp.sessionsControllerGetSessionById(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a session by its unique token (JTI)
         * @param {string} token The session token (JTI).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionByToken(token, options) {
            return localVarFp.sessionsControllerGetSessionByToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all active sessions for a user by their ID
         * @param {string} userId The user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionsByUserId(userId, options) {
            return localVarFp.sessionsControllerGetSessionsByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Revoke a session by its token.
         * @param {string} token The session token to revoke
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerRevokeSession(token, options) {
            return localVarFp.sessionsControllerRevokeSession(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a session by its ID
         * @param {string} sessionId The session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerSoftDeleteSession(sessionId, options) {
            return localVarFp.sessionsControllerSoftDeleteSession(sessionId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
    /**
     *
     * @summary Retrieve all sessions for a user by their ID
     * @param {string} userId The user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetAllSessionsByUserId(userId, options) {
        return SessionsApiFp(this.configuration).sessionsControllerGetAllSessionsByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a session by its unique ID
     * @param {string} sessionId The session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetSessionById(sessionId, options) {
        return SessionsApiFp(this.configuration).sessionsControllerGetSessionById(sessionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a session by its unique token (JTI)
     * @param {string} token The session token (JTI).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetSessionByToken(token, options) {
        return SessionsApiFp(this.configuration).sessionsControllerGetSessionByToken(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all active sessions for a user by their ID
     * @param {string} userId The user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerGetSessionsByUserId(userId, options) {
        return SessionsApiFp(this.configuration).sessionsControllerGetSessionsByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Revoke a session by its token.
     * @param {string} token The session token to revoke
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerRevokeSession(token, options) {
        return SessionsApiFp(this.configuration).sessionsControllerRevokeSession(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a session by its ID
     * @param {string} sessionId The session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsControllerSoftDeleteSession(sessionId, options) {
        return SessionsApiFp(this.configuration).sessionsControllerSoftDeleteSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TenantRegistryApi - axios parameter creator
 * @export
 */
export const TenantRegistryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retrieve tenant registry by CRM tenant slug
         * @param {string} crmTenantId CRM tenant slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryControllerFindByCrmTenantId: async (crmTenantId, options = {}) => {
            // verify required parameter 'crmTenantId' is not null or undefined
            assertParamExists('tenantRegistryControllerFindByCrmTenantId', 'crmTenantId', crmTenantId);
            const localVarPath = `/api/tenant-registry/by-crm/{crmTenantId}`
                .replace(`{${"crmTenantId"}}`, encodeURIComponent(String(crmTenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve tenant registry by Access Control tenant ID
         * @param {string} tenantId Access Control tenant ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryControllerFindByTenantId: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantRegistryControllerFindByTenantId', 'tenantId', tenantId);
            const localVarPath = `/api/tenant-registry/by-tenant/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve tenant registry by CRM tenant slug (service token)
         * @param {string} crmTenantId CRM tenant slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryInternalControllerFindByCrmTenantId: async (crmTenantId, options = {}) => {
            // verify required parameter 'crmTenantId' is not null or undefined
            assertParamExists('tenantRegistryInternalControllerFindByCrmTenantId', 'crmTenantId', crmTenantId);
            const localVarPath = `/api/internal/tenant-registry/by-crm/{crmTenantId}`
                .replace(`{${"crmTenantId"}}`, encodeURIComponent(String(crmTenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve tenant registry by Access Control tenant ID (service token)
         * @param {string} tenantId Access Control tenant ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryInternalControllerFindByTenantId: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantRegistryInternalControllerFindByTenantId', 'tenantId', tenantId);
            const localVarPath = `/api/internal/tenant-registry/by-tenant/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TenantRegistryApi - functional programming interface
 * @export
 */
export const TenantRegistryApiFp = function (configuration) {
    const localVarAxiosParamCreator = TenantRegistryApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Retrieve tenant registry by CRM tenant slug
         * @param {string} crmTenantId CRM tenant slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantRegistryControllerFindByCrmTenantId(crmTenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantRegistryControllerFindByCrmTenantId(crmTenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRegistryApi.tenantRegistryControllerFindByCrmTenantId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve tenant registry by Access Control tenant ID
         * @param {string} tenantId Access Control tenant ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantRegistryControllerFindByTenantId(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantRegistryControllerFindByTenantId(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRegistryApi.tenantRegistryControllerFindByTenantId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve tenant registry by CRM tenant slug (service token)
         * @param {string} crmTenantId CRM tenant slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantRegistryInternalControllerFindByCrmTenantId(crmTenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantRegistryInternalControllerFindByCrmTenantId(crmTenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRegistryApi.tenantRegistryInternalControllerFindByCrmTenantId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve tenant registry by Access Control tenant ID (service token)
         * @param {string} tenantId Access Control tenant ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantRegistryInternalControllerFindByTenantId(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantRegistryInternalControllerFindByTenantId(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantRegistryApi.tenantRegistryInternalControllerFindByTenantId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TenantRegistryApi - factory interface
 * @export
 */
export const TenantRegistryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TenantRegistryApiFp(configuration);
    return {
        /**
         *
         * @summary Retrieve tenant registry by CRM tenant slug
         * @param {string} crmTenantId CRM tenant slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryControllerFindByCrmTenantId(crmTenantId, options) {
            return localVarFp.tenantRegistryControllerFindByCrmTenantId(crmTenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve tenant registry by Access Control tenant ID
         * @param {string} tenantId Access Control tenant ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryControllerFindByTenantId(tenantId, options) {
            return localVarFp.tenantRegistryControllerFindByTenantId(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve tenant registry by CRM tenant slug (service token)
         * @param {string} crmTenantId CRM tenant slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryInternalControllerFindByCrmTenantId(crmTenantId, options) {
            return localVarFp.tenantRegistryInternalControllerFindByCrmTenantId(crmTenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve tenant registry by Access Control tenant ID (service token)
         * @param {string} tenantId Access Control tenant ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantRegistryInternalControllerFindByTenantId(tenantId, options) {
            return localVarFp.tenantRegistryInternalControllerFindByTenantId(tenantId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TenantRegistryApi - object-oriented interface
 * @export
 * @class TenantRegistryApi
 * @extends {BaseAPI}
 */
export class TenantRegistryApi extends BaseAPI {
    /**
     *
     * @summary Retrieve tenant registry by CRM tenant slug
     * @param {string} crmTenantId CRM tenant slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistryApi
     */
    tenantRegistryControllerFindByCrmTenantId(crmTenantId, options) {
        return TenantRegistryApiFp(this.configuration).tenantRegistryControllerFindByCrmTenantId(crmTenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve tenant registry by Access Control tenant ID
     * @param {string} tenantId Access Control tenant ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistryApi
     */
    tenantRegistryControllerFindByTenantId(tenantId, options) {
        return TenantRegistryApiFp(this.configuration).tenantRegistryControllerFindByTenantId(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve tenant registry by CRM tenant slug (service token)
     * @param {string} crmTenantId CRM tenant slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistryApi
     */
    tenantRegistryInternalControllerFindByCrmTenantId(crmTenantId, options) {
        return TenantRegistryApiFp(this.configuration).tenantRegistryInternalControllerFindByCrmTenantId(crmTenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve tenant registry by Access Control tenant ID (service token)
     * @param {string} tenantId Access Control tenant ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRegistryApi
     */
    tenantRegistryInternalControllerFindByTenantId(tenantId, options) {
        return TenantRegistryApiFp(this.configuration).tenantRegistryInternalControllerFindByTenantId(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns whether a VoicePro tenant slug is available for use. Used for preflight validation during onboarding.
         * @summary Check VoicePro tenant slug availability
         * @param {string} slug VoicePro tenant slug to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerCheckSlugAvailability: async (slug, options = {}) => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('tenantsControllerCheckSlugAvailability', 'slug', slug);
            const localVarPath = `/api/tenants/check-slug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new tenant
         * @param {CreateTenantDto} createTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerCreateTenant: async (createTenantDto, options = {}) => {
            // verify required parameter 'createTenantDto' is not null or undefined
            assertParamExists('tenantsControllerCreateTenant', 'createTenantDto', createTenantDto);
            const localVarPath = `/api/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all tenants with optional pagination
         * @param {number} [skip] Number of records to skip
         * @param {number} [take] Number of records to take (max 1000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindAllTenants: async (skip, take, options = {}) => {
            const localVarPath = `/api/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a tenant by its ID
         * @param {string} tenantId The ID of the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindTenantById: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerFindTenantById', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns step-by-step provisioning status for a tenant onboarding job.
         * @summary Retrieve tenant provisioning job status
         * @param {string} jobId Provisioning job ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerGetProvisioningJobStatus: async (jobId, options = {}) => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('tenantsControllerGetProvisioningJobStatus', 'jobId', jobId);
            const localVarPath = `/api/tenants/provision/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns known VoicePro tenant slugs (normalized to lowercase) for autocomplete in operator provisioning flows.
         * @summary List known VoicePro tenant slugs from the registry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerListVoiceProTenantSlugs: async (options = {}) => {
            const localVarPath = `/api/tenants/voicepro/tenant-slugs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a tenant
         * @param {string} tenantId The ID of the tenant to permanently delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerPermanentlyDeleteTenant: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerPermanentlyDeleteTenant', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}/permanent`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Template-based tenant provisioning. Supports voicepro-customer, voicepro-operator, corporate, and facilities-leasing templates.
         * @summary Provision a tenant using a template
         * @param {ProvisionTenantDto} provisionTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerProvisionTenant: async (provisionTenantDto, options = {}) => {
            // verify required parameter 'provisionTenantDto' is not null or undefined
            assertParamExists('tenantsControllerProvisionTenant', 'provisionTenantDto', provisionTenantDto);
            const localVarPath = `/api/tenants/provision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(provisionTenantDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted tenant
         * @param {string} tenantId The ID of the tenant to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerRestoreTenant: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerRestoreTenant', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}/restore`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a tenant
         * @param {string} tenantId The ID of the tenant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerSoftDeleteTenant: async (tenantId, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerSoftDeleteTenant', 'tenantId', tenantId);
            const localVarPath = `/api/tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a tenant\'s details
         * @param {string} tenantId The ID of the tenant to update
         * @param {UpdateTenantDto} updateTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerUpdateTenant: async (tenantId, updateTenantDto, options = {}) => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('tenantsControllerUpdateTenant', 'tenantId', tenantId);
            // verify required parameter 'updateTenantDto' is not null or undefined
            assertParamExists('tenantsControllerUpdateTenant', 'updateTenantDto', updateTenantDto);
            const localVarPath = `/api/tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns whether a VoicePro tenant slug is available for use. Used for preflight validation during onboarding.
         * @summary Check VoicePro tenant slug availability
         * @param {string} slug VoicePro tenant slug to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerCheckSlugAvailability(slug, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerCheckSlugAvailability(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerCheckSlugAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new tenant
         * @param {CreateTenantDto} createTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerCreateTenant(createTenantDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerCreateTenant(createTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerCreateTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all tenants with optional pagination
         * @param {number} [skip] Number of records to skip
         * @param {number} [take] Number of records to take (max 1000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerFindAllTenants(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerFindAllTenants(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerFindAllTenants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a tenant by its ID
         * @param {string} tenantId The ID of the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerFindTenantById(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerFindTenantById(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerFindTenantById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns step-by-step provisioning status for a tenant onboarding job.
         * @summary Retrieve tenant provisioning job status
         * @param {string} jobId Provisioning job ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerGetProvisioningJobStatus(jobId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerGetProvisioningJobStatus(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerGetProvisioningJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns known VoicePro tenant slugs (normalized to lowercase) for autocomplete in operator provisioning flows.
         * @summary List known VoicePro tenant slugs from the registry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerListVoiceProTenantSlugs(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerListVoiceProTenantSlugs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerListVoiceProTenantSlugs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a tenant
         * @param {string} tenantId The ID of the tenant to permanently delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerPermanentlyDeleteTenant(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerPermanentlyDeleteTenant(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerPermanentlyDeleteTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Template-based tenant provisioning. Supports voicepro-customer, voicepro-operator, corporate, and facilities-leasing templates.
         * @summary Provision a tenant using a template
         * @param {ProvisionTenantDto} provisionTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerProvisionTenant(provisionTenantDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerProvisionTenant(provisionTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerProvisionTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted tenant
         * @param {string} tenantId The ID of the tenant to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerRestoreTenant(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerRestoreTenant(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerRestoreTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a tenant
         * @param {string} tenantId The ID of the tenant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerSoftDeleteTenant(tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerSoftDeleteTenant(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerSoftDeleteTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a tenant\'s details
         * @param {string} tenantId The ID of the tenant to update
         * @param {UpdateTenantDto} updateTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsControllerUpdateTenant(tenantId, updateTenantDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsControllerUpdateTenant(tenantId, updateTenantDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsApi.tenantsControllerUpdateTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TenantsApiFp(configuration);
    return {
        /**
         * Returns whether a VoicePro tenant slug is available for use. Used for preflight validation during onboarding.
         * @summary Check VoicePro tenant slug availability
         * @param {string} slug VoicePro tenant slug to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerCheckSlugAvailability(slug, options) {
            return localVarFp.tenantsControllerCheckSlugAvailability(slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new tenant
         * @param {CreateTenantDto} createTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerCreateTenant(createTenantDto, options) {
            return localVarFp.tenantsControllerCreateTenant(createTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all tenants with optional pagination
         * @param {number} [skip] Number of records to skip
         * @param {number} [take] Number of records to take (max 1000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindAllTenants(skip, take, options) {
            return localVarFp.tenantsControllerFindAllTenants(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a tenant by its ID
         * @param {string} tenantId The ID of the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerFindTenantById(tenantId, options) {
            return localVarFp.tenantsControllerFindTenantById(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns step-by-step provisioning status for a tenant onboarding job.
         * @summary Retrieve tenant provisioning job status
         * @param {string} jobId Provisioning job ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerGetProvisioningJobStatus(jobId, options) {
            return localVarFp.tenantsControllerGetProvisioningJobStatus(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns known VoicePro tenant slugs (normalized to lowercase) for autocomplete in operator provisioning flows.
         * @summary List known VoicePro tenant slugs from the registry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerListVoiceProTenantSlugs(options) {
            return localVarFp.tenantsControllerListVoiceProTenantSlugs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a tenant
         * @param {string} tenantId The ID of the tenant to permanently delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerPermanentlyDeleteTenant(tenantId, options) {
            return localVarFp.tenantsControllerPermanentlyDeleteTenant(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Template-based tenant provisioning. Supports voicepro-customer, voicepro-operator, corporate, and facilities-leasing templates.
         * @summary Provision a tenant using a template
         * @param {ProvisionTenantDto} provisionTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerProvisionTenant(provisionTenantDto, options) {
            return localVarFp.tenantsControllerProvisionTenant(provisionTenantDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted tenant
         * @param {string} tenantId The ID of the tenant to restore
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerRestoreTenant(tenantId, options) {
            return localVarFp.tenantsControllerRestoreTenant(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a tenant
         * @param {string} tenantId The ID of the tenant to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerSoftDeleteTenant(tenantId, options) {
            return localVarFp.tenantsControllerSoftDeleteTenant(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a tenant\'s details
         * @param {string} tenantId The ID of the tenant to update
         * @param {UpdateTenantDto} updateTenantDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsControllerUpdateTenant(tenantId, updateTenantDto, options) {
            return localVarFp.tenantsControllerUpdateTenant(tenantId, updateTenantDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI {
    /**
     * Returns whether a VoicePro tenant slug is available for use. Used for preflight validation during onboarding.
     * @summary Check VoicePro tenant slug availability
     * @param {string} slug VoicePro tenant slug to check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerCheckSlugAvailability(slug, options) {
        return TenantsApiFp(this.configuration).tenantsControllerCheckSlugAvailability(slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new tenant
     * @param {CreateTenantDto} createTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerCreateTenant(createTenantDto, options) {
        return TenantsApiFp(this.configuration).tenantsControllerCreateTenant(createTenantDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all tenants with optional pagination
     * @param {number} [skip] Number of records to skip
     * @param {number} [take] Number of records to take (max 1000)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerFindAllTenants(skip, take, options) {
        return TenantsApiFp(this.configuration).tenantsControllerFindAllTenants(skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a tenant by its ID
     * @param {string} tenantId The ID of the tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerFindTenantById(tenantId, options) {
        return TenantsApiFp(this.configuration).tenantsControllerFindTenantById(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns step-by-step provisioning status for a tenant onboarding job.
     * @summary Retrieve tenant provisioning job status
     * @param {string} jobId Provisioning job ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerGetProvisioningJobStatus(jobId, options) {
        return TenantsApiFp(this.configuration).tenantsControllerGetProvisioningJobStatus(jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns known VoicePro tenant slugs (normalized to lowercase) for autocomplete in operator provisioning flows.
     * @summary List known VoicePro tenant slugs from the registry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerListVoiceProTenantSlugs(options) {
        return TenantsApiFp(this.configuration).tenantsControllerListVoiceProTenantSlugs(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a tenant
     * @param {string} tenantId The ID of the tenant to permanently delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerPermanentlyDeleteTenant(tenantId, options) {
        return TenantsApiFp(this.configuration).tenantsControllerPermanentlyDeleteTenant(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Template-based tenant provisioning. Supports voicepro-customer, voicepro-operator, corporate, and facilities-leasing templates.
     * @summary Provision a tenant using a template
     * @param {ProvisionTenantDto} provisionTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerProvisionTenant(provisionTenantDto, options) {
        return TenantsApiFp(this.configuration).tenantsControllerProvisionTenant(provisionTenantDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted tenant
     * @param {string} tenantId The ID of the tenant to restore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerRestoreTenant(tenantId, options) {
        return TenantsApiFp(this.configuration).tenantsControllerRestoreTenant(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a tenant
     * @param {string} tenantId The ID of the tenant to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerSoftDeleteTenant(tenantId, options) {
        return TenantsApiFp(this.configuration).tenantsControllerSoftDeleteTenant(tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a tenant\'s details
     * @param {string} tenantId The ID of the tenant to update
     * @param {UpdateTenantDto} updateTenantDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    tenantsControllerUpdateTenant(tenantId, updateTenantDto, options) {
        return TenantsApiFp(this.configuration).tenantsControllerUpdateTenant(tenantId, updateTenantDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserProfilesApi - axios parameter creator
 * @export
 */
export const UserProfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Bulk restore user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesBulkControllerBulkRestoreProfiles: async (bulkProfileIdsDto, options = {}) => {
            // verify required parameter 'bulkProfileIdsDto' is not null or undefined
            assertParamExists('userProfilesBulkControllerBulkRestoreProfiles', 'bulkProfileIdsDto', bulkProfileIdsDto);
            const localVarPath = `/api/user-profiles/bulk-restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkProfileIdsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Bulk soft-delete user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesBulkControllerBulkSoftDeleteProfiles: async (bulkProfileIdsDto, options = {}) => {
            // verify required parameter 'bulkProfileIdsDto' is not null or undefined
            assertParamExists('userProfilesBulkControllerBulkSoftDeleteProfiles', 'bulkProfileIdsDto', bulkProfileIdsDto);
            const localVarPath = `/api/user-profiles/bulk-soft-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkProfileIdsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new user profile
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfile: async (createUserProfileDto, options = {}) => {
            // verify required parameter 'createUserProfileDto' is not null or undefined
            assertParamExists('userProfilesControllerCreateUserProfile', 'createUserProfileDto', createUserProfileDto);
            const localVarPath = `/api/user-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new user profile with a duplicate check
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfileWithDuplicateCheck: async (createUserProfileDto, options = {}) => {
            // verify required parameter 'createUserProfileDto' is not null or undefined
            assertParamExists('userProfilesControllerCreateUserProfileWithDuplicateCheck', 'createUserProfileDto', createUserProfileDto);
            const localVarPath = `/api/user-profiles/duplicate-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerPermanentlyDeleteUserProfile: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerPermanentlyDeleteUserProfile', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerRestoreUserProfile: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerRestoreUserProfile', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}/restore`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerSoftDeleteUserProfile: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesControllerSoftDeleteUserProfile', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}/soft-delete`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update an existing user profile
         * @param {UpdateUserProfileDto} updateUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerUpdateUserProfile: async (updateUserProfileDto, options = {}) => {
            // verify required parameter 'updateUserProfileDto' is not null or undefined
            assertParamExists('userProfilesControllerUpdateUserProfile', 'updateUserProfileDto', updateUserProfileDto);
            const localVarPath = `/api/user-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserProfileDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all user profiles (paginated)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesQueryControllerGetAllUserProfiles: async (skip, take, options = {}) => {
            const localVarPath = `/api/user-profiles/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a user profile by its unique DB ID
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesQueryControllerGetUserProfileById: async (profileId, options = {}) => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('userProfilesQueryControllerGetUserProfileById', 'profileId', profileId);
            const localVarPath = `/api/user-profiles/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a user profile by userId + provider
         * @param {string} userId User ID
         * @param {string} provider Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesQueryControllerGetUserProfileByUserAndProvider: async (userId, provider, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userProfilesQueryControllerGetUserProfileByUserAndProvider', 'userId', userId);
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('userProfilesQueryControllerGetUserProfileByUserAndProvider', 'provider', provider);
            const localVarPath = `/api/user-profiles/by-user-and-provider/{userId}/{provider}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserProfilesApi - functional programming interface
 * @export
 */
export const UserProfilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserProfilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Bulk restore user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesBulkControllerBulkRestoreProfiles(bulkProfileIdsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesBulkControllerBulkRestoreProfiles(bulkProfileIdsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesBulkControllerBulkRestoreProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Bulk soft-delete user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesBulkControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesBulkControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesBulkControllerBulkSoftDeleteProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new user profile
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerCreateUserProfile(createUserProfileDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerCreateUserProfile(createUserProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerCreateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new user profile with a duplicate check
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerCreateUserProfileWithDuplicateCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerPermanentlyDeleteUserProfile(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerPermanentlyDeleteUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerPermanentlyDeleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerRestoreUserProfile(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerRestoreUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerRestoreUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerSoftDeleteUserProfile(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerSoftDeleteUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerSoftDeleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update an existing user profile
         * @param {UpdateUserProfileDto} updateUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesControllerUpdateUserProfile(updateUserProfileDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesControllerUpdateUserProfile(updateUserProfileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesControllerUpdateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all user profiles (paginated)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesQueryControllerGetAllUserProfiles(skip, take, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesQueryControllerGetAllUserProfiles(skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesQueryControllerGetAllUserProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a user profile by its unique DB ID
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesQueryControllerGetUserProfileById(profileId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesQueryControllerGetUserProfileById(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesQueryControllerGetUserProfileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a user profile by userId + provider
         * @param {string} userId User ID
         * @param {string} provider Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfilesQueryControllerGetUserProfileByUserAndProvider(userId, provider, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfilesQueryControllerGetUserProfileByUserAndProvider(userId, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfilesApi.userProfilesQueryControllerGetUserProfileByUserAndProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserProfilesApi - factory interface
 * @export
 */
export const UserProfilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserProfilesApiFp(configuration);
    return {
        /**
         *
         * @summary Bulk restore user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesBulkControllerBulkRestoreProfiles(bulkProfileIdsDto, options) {
            return localVarFp.userProfilesBulkControllerBulkRestoreProfiles(bulkProfileIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bulk soft-delete user profiles
         * @param {BulkProfileIdsDto} bulkProfileIdsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesBulkControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options) {
            return localVarFp.userProfilesBulkControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user profile
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfile(createUserProfileDto, options) {
            return localVarFp.userProfilesControllerCreateUserProfile(createUserProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user profile with a duplicate check
         * @param {CreateUserProfileDto} createUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options) {
            return localVarFp.userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerPermanentlyDeleteUserProfile(profileId, options) {
            return localVarFp.userProfilesControllerPermanentlyDeleteUserProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerRestoreUserProfile(profileId, options) {
            return localVarFp.userProfilesControllerRestoreUserProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a user profile
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerSoftDeleteUserProfile(profileId, options) {
            return localVarFp.userProfilesControllerSoftDeleteUserProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing user profile
         * @param {UpdateUserProfileDto} updateUserProfileDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesControllerUpdateUserProfile(updateUserProfileDto, options) {
            return localVarFp.userProfilesControllerUpdateUserProfile(updateUserProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all user profiles (paginated)
         * @param {number} [skip] Records to skip
         * @param {number} [take] Records to take
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesQueryControllerGetAllUserProfiles(skip, take, options) {
            return localVarFp.userProfilesQueryControllerGetAllUserProfiles(skip, take, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a user profile by its unique DB ID
         * @param {string} profileId Profile ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesQueryControllerGetUserProfileById(profileId, options) {
            return localVarFp.userProfilesQueryControllerGetUserProfileById(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a user profile by userId + provider
         * @param {string} userId User ID
         * @param {string} provider Provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfilesQueryControllerGetUserProfileByUserAndProvider(userId, provider, options) {
            return localVarFp.userProfilesQueryControllerGetUserProfileByUserAndProvider(userId, provider, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserProfilesApi - object-oriented interface
 * @export
 * @class UserProfilesApi
 * @extends {BaseAPI}
 */
export class UserProfilesApi extends BaseAPI {
    /**
     *
     * @summary Bulk restore user profiles
     * @param {BulkProfileIdsDto} bulkProfileIdsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesBulkControllerBulkRestoreProfiles(bulkProfileIdsDto, options) {
        return UserProfilesApiFp(this.configuration).userProfilesBulkControllerBulkRestoreProfiles(bulkProfileIdsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Bulk soft-delete user profiles
     * @param {BulkProfileIdsDto} bulkProfileIdsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesBulkControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options) {
        return UserProfilesApiFp(this.configuration).userProfilesBulkControllerBulkSoftDeleteProfiles(bulkProfileIdsDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user profile
     * @param {CreateUserProfileDto} createUserProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerCreateUserProfile(createUserProfileDto, options) {
        return UserProfilesApiFp(this.configuration).userProfilesControllerCreateUserProfile(createUserProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user profile with a duplicate check
     * @param {CreateUserProfileDto} createUserProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options) {
        return UserProfilesApiFp(this.configuration).userProfilesControllerCreateUserProfileWithDuplicateCheck(createUserProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a user profile
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerPermanentlyDeleteUserProfile(profileId, options) {
        return UserProfilesApiFp(this.configuration).userProfilesControllerPermanentlyDeleteUserProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted user profile
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerRestoreUserProfile(profileId, options) {
        return UserProfilesApiFp(this.configuration).userProfilesControllerRestoreUserProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a user profile
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerSoftDeleteUserProfile(profileId, options) {
        return UserProfilesApiFp(this.configuration).userProfilesControllerSoftDeleteUserProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing user profile
     * @param {UpdateUserProfileDto} updateUserProfileDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesControllerUpdateUserProfile(updateUserProfileDto, options) {
        return UserProfilesApiFp(this.configuration).userProfilesControllerUpdateUserProfile(updateUserProfileDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all user profiles (paginated)
     * @param {number} [skip] Records to skip
     * @param {number} [take] Records to take
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesQueryControllerGetAllUserProfiles(skip, take, options) {
        return UserProfilesApiFp(this.configuration).userProfilesQueryControllerGetAllUserProfiles(skip, take, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a user profile by its unique DB ID
     * @param {string} profileId Profile ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesQueryControllerGetUserProfileById(profileId, options) {
        return UserProfilesApiFp(this.configuration).userProfilesQueryControllerGetUserProfileById(profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a user profile by userId + provider
     * @param {string} userId User ID
     * @param {string} provider Provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfilesApi
     */
    userProfilesQueryControllerGetUserProfileByUserAndProvider(userId, provider, options) {
        return UserProfilesApiFp(this.configuration).userProfilesQueryControllerGetUserProfileByUserAndProvider(userId, provider, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserRolesApi - axios parameter creator
 * @export
 */
export const UserRolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Assign a single role to a user
         * @param {AssignRoleToUserDto} assignRoleToUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerAssignRoleToUser: async (assignRoleToUserDto, options = {}) => {
            // verify required parameter 'assignRoleToUserDto' is not null or undefined
            assertParamExists('userRolesControllerAssignRoleToUser', 'assignRoleToUserDto', assignRoleToUserDto);
            const localVarPath = `/api/user-roles/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(assignRoleToUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Bulk assign multiple roles to a user
         * @param {BulkAssignRolesDto} bulkAssignRolesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerBulkAssignRolesToUser: async (bulkAssignRolesDto, options = {}) => {
            // verify required parameter 'bulkAssignRolesDto' is not null or undefined
            assertParamExists('userRolesControllerBulkAssignRolesToUser', 'bulkAssignRolesDto', bulkAssignRolesDto);
            const localVarPath = `/api/user-roles/bulk-assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAssignRolesDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a role from a user by deleting the pivot record
         * @param {string} [pivotId] Pivot ID, if known
         * @param {string} [userId] User ID
         * @param {string} [roleId] Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerRemoveUserRole: async (pivotId, userId, roleId, options = {}) => {
            const localVarPath = `/api/user-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (pivotId !== undefined) {
                localVarQueryParameter['pivotId'] = pivotId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a UserRole pivot record
         * @param {string} pivotId The ID of the UserRole pivot
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerUpdateUserRole: async (pivotId, updateUserRoleDto, options = {}) => {
            // verify required parameter 'pivotId' is not null or undefined
            assertParamExists('userRolesControllerUpdateUserRole', 'pivotId', pivotId);
            // verify required parameter 'updateUserRoleDto' is not null or undefined
            assertParamExists('userRolesControllerUpdateUserRole', 'updateUserRoleDto', updateUserRoleDto);
            const localVarPath = `/api/user-roles/{pivotId}`
                .replace(`{${"pivotId"}}`, encodeURIComponent(String(pivotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserRolesApi - functional programming interface
 * @export
 */
export const UserRolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserRolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Assign a single role to a user
         * @param {AssignRoleToUserDto} assignRoleToUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerAssignRoleToUser(assignRoleToUserDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerAssignRoleToUser(assignRoleToUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerAssignRoleToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Bulk assign multiple roles to a user
         * @param {BulkAssignRolesDto} bulkAssignRolesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerBulkAssignRolesToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove a role from a user by deleting the pivot record
         * @param {string} [pivotId] Pivot ID, if known
         * @param {string} [userId] User ID
         * @param {string} [roleId] Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerRemoveUserRole(pivotId, userId, roleId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerRemoveUserRole(pivotId, userId, roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerRemoveUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a UserRole pivot record
         * @param {string} pivotId The ID of the UserRole pivot
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserRolesApi.userRolesControllerUpdateUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserRolesApi - factory interface
 * @export
 */
export const UserRolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserRolesApiFp(configuration);
    return {
        /**
         *
         * @summary Assign a single role to a user
         * @param {AssignRoleToUserDto} assignRoleToUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerAssignRoleToUser(assignRoleToUserDto, options) {
            return localVarFp.userRolesControllerAssignRoleToUser(assignRoleToUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bulk assign multiple roles to a user
         * @param {BulkAssignRolesDto} bulkAssignRolesDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options) {
            return localVarFp.userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a role from a user by deleting the pivot record
         * @param {string} [pivotId] Pivot ID, if known
         * @param {string} [userId] User ID
         * @param {string} [roleId] Role ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerRemoveUserRole(pivotId, userId, roleId, options) {
            return localVarFp.userRolesControllerRemoveUserRole(pivotId, userId, roleId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a UserRole pivot record
         * @param {string} pivotId The ID of the UserRole pivot
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options) {
            return localVarFp.userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserRolesApi - object-oriented interface
 * @export
 * @class UserRolesApi
 * @extends {BaseAPI}
 */
export class UserRolesApi extends BaseAPI {
    /**
     *
     * @summary Assign a single role to a user
     * @param {AssignRoleToUserDto} assignRoleToUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerAssignRoleToUser(assignRoleToUserDto, options) {
        return UserRolesApiFp(this.configuration).userRolesControllerAssignRoleToUser(assignRoleToUserDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Bulk assign multiple roles to a user
     * @param {BulkAssignRolesDto} bulkAssignRolesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options) {
        return UserRolesApiFp(this.configuration).userRolesControllerBulkAssignRolesToUser(bulkAssignRolesDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a role from a user by deleting the pivot record
     * @param {string} [pivotId] Pivot ID, if known
     * @param {string} [userId] User ID
     * @param {string} [roleId] Role ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerRemoveUserRole(pivotId, userId, roleId, options) {
        return UserRolesApiFp(this.configuration).userRolesControllerRemoveUserRole(pivotId, userId, roleId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a UserRole pivot record
     * @param {string} pivotId The ID of the UserRole pivot
     * @param {UpdateUserRoleDto} updateUserRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options) {
        return UserRolesApiFp(this.configuration).userRolesControllerUpdateUserRole(pivotId, updateUserRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Change a user\'s password
         * @param {any} userId User ID (UUID)
         * @param {ChangePasswordDto} changePasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangePassword: async (userId, changePasswordDto, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerChangePassword', 'userId', userId);
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('usersControllerChangePassword', 'changePasswordDto', changePasswordDto);
            const localVarPath = `/api/users/{userId}/password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Change a user\'s role
         * @param {any} userId User ID (UUID)
         * @param {ChangeUserRoleDto} changeUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangeUserRole: async (userId, changeUserRoleDto, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerChangeUserRole', 'userId', userId);
            // verify required parameter 'changeUserRoleDto' is not null or undefined
            assertParamExists('usersControllerChangeUserRole', 'changeUserRoleDto', changeUserRoleDto);
            const localVarPath = `/api/users/{userId}/role`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(changeUserRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreateUser: async (createUserDto, options = {}) => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('usersControllerCreateUser', 'createUserDto', createUserDto);
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Permanently delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerPermanentlyDeleteUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerPermanentlyDeleteUser', 'userId', userId);
            const localVarPath = `/api/users/{userId}/permanent`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a soft-deleted user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRestoreUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerRestoreUser', 'userId', userId);
            const localVarPath = `/api/users/{userId}/restore`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Soft delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSoftDeleteUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerSoftDeleteUser', 'userId', userId);
            const localVarPath = `/api/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update user details
         * @param {string} userId User ID (UUID)
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUser: async (userId, updateUserDto, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerUpdateUser', 'userId', userId);
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('usersControllerUpdateUser', 'updateUserDto', updateUserDto);
            const localVarPath = `/api/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a user\'s status (e.g., ACTIVE/INACTIVE/SUSPENDED)
         * @param {string} userId User ID (UUID)
         * @param {UsersControllerUpdateUserStatusRequest} usersControllerUpdateUserStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUserStatus: async (userId, usersControllerUpdateUserStatusRequest, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerUpdateUserStatus', 'userId', userId);
            // verify required parameter 'usersControllerUpdateUserStatusRequest' is not null or undefined
            assertParamExists('usersControllerUpdateUserStatus', 'usersControllerUpdateUserStatusRequest', usersControllerUpdateUserStatusRequest);
            const localVarPath = `/api/users/{userId}/status`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(usersControllerUpdateUserStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve all users with optional pagination and filtering
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {number} [take] Records to take (max 100)
         * @param {number} [skip] Records to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerFindAllUsers: async (tenantId, take, skip, options = {}) => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerFindUserByEmail: async (email, options = {}) => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('usersQueryControllerFindUserByEmail', 'email', email);
            const localVarPath = `/api/users/by-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retrieve a user by their UserId
         * @param {any} userId User ID (UUID)
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerGetUserById: async (userId, tenantId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersQueryControllerGetUserById', 'userId', userId);
            const localVarPath = `/api/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search for users based on filters and pagination
         * @param {number} [take] Records to take (max 100)
         * @param {number} [skip] Records to skip
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {string} [role] Role filter
         * @param {string} [email] Email filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerSearchUsers: async (take, skip, tenantId, role, email, options = {}) => {
            const localVarPath = `/api/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Change a user\'s password
         * @param {any} userId User ID (UUID)
         * @param {ChangePasswordDto} changePasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerChangePassword(userId, changePasswordDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerChangePassword(userId, changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerChangePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Change a user\'s role
         * @param {any} userId User ID (UUID)
         * @param {ChangeUserRoleDto} changeUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerChangeUserRole(userId, changeUserRoleDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerChangeUserRole(userId, changeUserRoleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerChangeUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerCreateUser(createUserDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerCreateUser(createUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerCreateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Permanently delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerPermanentlyDeleteUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerPermanentlyDeleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerPermanentlyDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a soft-deleted user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerRestoreUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerRestoreUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerRestoreUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Soft delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSoftDeleteUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSoftDeleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerSoftDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update user details
         * @param {string} userId User ID (UUID)
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateUser(userId, updateUserDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateUser(userId, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerUpdateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a user\'s status (e.g., ACTIVE/INACTIVE/SUSPENDED)
         * @param {string} userId User ID (UUID)
         * @param {UsersControllerUpdateUserStatusRequest} usersControllerUpdateUserStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateUserStatus(userId, usersControllerUpdateUserStatusRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateUserStatus(userId, usersControllerUpdateUserStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerUpdateUserStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve all users with optional pagination and filtering
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {number} [take] Records to take (max 100)
         * @param {number} [skip] Records to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersQueryControllerFindAllUsers(tenantId, take, skip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersQueryControllerFindAllUsers(tenantId, take, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersQueryControllerFindAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersQueryControllerFindUserByEmail(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersQueryControllerFindUserByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersQueryControllerFindUserByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Retrieve a user by their UserId
         * @param {any} userId User ID (UUID)
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersQueryControllerGetUserById(userId, tenantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersQueryControllerGetUserById(userId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersQueryControllerGetUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search for users based on filters and pagination
         * @param {number} [take] Records to take (max 100)
         * @param {number} [skip] Records to skip
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {string} [role] Role filter
         * @param {string} [email] Email filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersQueryControllerSearchUsers(take, skip, tenantId, role, email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersQueryControllerSearchUsers(take, skip, tenantId, role, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersQueryControllerSearchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @summary Change a user\'s password
         * @param {any} userId User ID (UUID)
         * @param {ChangePasswordDto} changePasswordDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangePassword(userId, changePasswordDto, options) {
            return localVarFp.usersControllerChangePassword(userId, changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change a user\'s role
         * @param {any} userId User ID (UUID)
         * @param {ChangeUserRoleDto} changeUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerChangeUserRole(userId, changeUserRoleDto, options) {
            return localVarFp.usersControllerChangeUserRole(userId, changeUserRoleDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreateUser(createUserDto, options) {
            return localVarFp.usersControllerCreateUser(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Permanently delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerPermanentlyDeleteUser(userId, options) {
            return localVarFp.usersControllerPermanentlyDeleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a soft-deleted user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRestoreUser(userId, options) {
            return localVarFp.usersControllerRestoreUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft delete a user
         * @param {string} userId User ID (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSoftDeleteUser(userId, options) {
            return localVarFp.usersControllerSoftDeleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user details
         * @param {string} userId User ID (UUID)
         * @param {UpdateUserDto} updateUserDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUser(userId, updateUserDto, options) {
            return localVarFp.usersControllerUpdateUser(userId, updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a user\'s status (e.g., ACTIVE/INACTIVE/SUSPENDED)
         * @param {string} userId User ID (UUID)
         * @param {UsersControllerUpdateUserStatusRequest} usersControllerUpdateUserStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUserStatus(userId, usersControllerUpdateUserStatusRequest, options) {
            return localVarFp.usersControllerUpdateUserStatus(userId, usersControllerUpdateUserStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve all users with optional pagination and filtering
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {number} [take] Records to take (max 100)
         * @param {number} [skip] Records to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerFindAllUsers(tenantId, take, skip, options) {
            return localVarFp.usersQueryControllerFindAllUsers(tenantId, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerFindUserByEmail(email, options) {
            return localVarFp.usersQueryControllerFindUserByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a user by their UserId
         * @param {any} userId User ID (UUID)
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerGetUserById(userId, tenantId, options) {
            return localVarFp.usersQueryControllerGetUserById(userId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search for users based on filters and pagination
         * @param {number} [take] Records to take (max 100)
         * @param {number} [skip] Records to skip
         * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
         * @param {string} [role] Role filter
         * @param {string} [email] Email filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersQueryControllerSearchUsers(take, skip, tenantId, role, email, options) {
            return localVarFp.usersQueryControllerSearchUsers(take, skip, tenantId, role, email, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @summary Change a user\'s password
     * @param {any} userId User ID (UUID)
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerChangePassword(userId, changePasswordDto, options) {
        return UsersApiFp(this.configuration).usersControllerChangePassword(userId, changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Change a user\'s role
     * @param {any} userId User ID (UUID)
     * @param {ChangeUserRoleDto} changeUserRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerChangeUserRole(userId, changeUserRoleDto, options) {
        return UsersApiFp(this.configuration).usersControllerChangeUserRole(userId, changeUserRoleDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new user
     * @param {CreateUserDto} createUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerCreateUser(createUserDto, options) {
        return UsersApiFp(this.configuration).usersControllerCreateUser(createUserDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Permanently delete a user
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerPermanentlyDeleteUser(userId, options) {
        return UsersApiFp(this.configuration).usersControllerPermanentlyDeleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a soft-deleted user
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerRestoreUser(userId, options) {
        return UsersApiFp(this.configuration).usersControllerRestoreUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft delete a user
     * @param {string} userId User ID (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerSoftDeleteUser(userId, options) {
        return UsersApiFp(this.configuration).usersControllerSoftDeleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user details
     * @param {string} userId User ID (UUID)
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerUpdateUser(userId, updateUserDto, options) {
        return UsersApiFp(this.configuration).usersControllerUpdateUser(userId, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a user\'s status (e.g., ACTIVE/INACTIVE/SUSPENDED)
     * @param {string} userId User ID (UUID)
     * @param {UsersControllerUpdateUserStatusRequest} usersControllerUpdateUserStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersControllerUpdateUserStatus(userId, usersControllerUpdateUserStatusRequest, options) {
        return UsersApiFp(this.configuration).usersControllerUpdateUserStatus(userId, usersControllerUpdateUserStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve all users with optional pagination and filtering
     * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
     * @param {number} [take] Records to take (max 100)
     * @param {number} [skip] Records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersQueryControllerFindAllUsers(tenantId, take, skip, options) {
        return UsersApiFp(this.configuration).usersQueryControllerFindAllUsers(tenantId, take, skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersQueryControllerFindUserByEmail(email, options) {
        return UsersApiFp(this.configuration).usersQueryControllerFindUserByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a user by their UserId
     * @param {any} userId User ID (UUID)
     * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersQueryControllerGetUserById(userId, tenantId, options) {
        return UsersApiFp(this.configuration).usersQueryControllerGetUserById(userId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search for users based on filters and pagination
     * @param {number} [take] Records to take (max 100)
     * @param {number} [skip] Records to skip
     * @param {string} [tenantId] Tenant ID filter. Required unless the caller is a platform.superadmin.
     * @param {string} [role] Role filter
     * @param {string} [email] Email filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersQueryControllerSearchUsers(take, skip, tenantId, role, email, options) {
        return UsersApiFp(this.configuration).usersQueryControllerSearchUsers(take, skip, tenantId, role, email, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WhatsAppHealthApi - axios parameter creator
 * @export
 */
export const WhatsAppHealthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} template
         * @param {string} lang
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppHealthControllerGet: async (template, lang, options = {}) => {
            // verify required parameter 'template' is not null or undefined
            assertParamExists('whatsAppHealthControllerGet', 'template', template);
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('whatsAppHealthControllerGet', 'lang', lang);
            const localVarPath = `/api/messaging/whatsapp/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (template !== undefined) {
                localVarQueryParameter['template'] = template;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WhatsAppHealthApi - functional programming interface
 * @export
 */
export const WhatsAppHealthApiFp = function (configuration) {
    const localVarAxiosParamCreator = WhatsAppHealthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} template
         * @param {string} lang
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppHealthControllerGet(template, lang, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppHealthControllerGet(template, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppHealthApi.whatsAppHealthControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WhatsAppHealthApi - factory interface
 * @export
 */
export const WhatsAppHealthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WhatsAppHealthApiFp(configuration);
    return {
        /**
         *
         * @param {string} template
         * @param {string} lang
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppHealthControllerGet(template, lang, options) {
            return localVarFp.whatsAppHealthControllerGet(template, lang, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WhatsAppHealthApi - object-oriented interface
 * @export
 * @class WhatsAppHealthApi
 * @extends {BaseAPI}
 */
export class WhatsAppHealthApi extends BaseAPI {
    /**
     *
     * @param {string} template
     * @param {string} lang
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppHealthApi
     */
    whatsAppHealthControllerGet(template, lang, options) {
        return WhatsAppHealthApiFp(this.configuration).whatsAppHealthControllerGet(template, lang, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WhatsAppWebhookApi - axios parameter creator
 * @export
 */
export const WhatsAppWebhookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleVerify: async (options = {}) => {
            const localVarPath = `/api/messaging/webhook/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleWebhook: async (options = {}) => {
            const localVarPath = `/api/messaging/webhook/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHealth: async (options = {}) => {
            const localVarPath = `/api/messaging/webhook/whatsapp/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WhatsAppWebhookApi - functional programming interface
 * @export
 */
export const WhatsAppWebhookApiFp = function (configuration) {
    const localVarAxiosParamCreator = WhatsAppWebhookApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhookControllerHandleVerify(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhookControllerHandleVerify(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppWebhookApi.whatsAppWebhookControllerHandleVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhookControllerHandleWebhook(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhookControllerHandleWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppWebhookApi.whatsAppWebhookControllerHandleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhookControllerHealth(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhookControllerHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhatsAppWebhookApi.whatsAppWebhookControllerHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WhatsAppWebhookApi - factory interface
 * @export
 */
export const WhatsAppWebhookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WhatsAppWebhookApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleVerify(options) {
            return localVarFp.whatsAppWebhookControllerHandleVerify(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHandleWebhook(options) {
            return localVarFp.whatsAppWebhookControllerHandleWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhookControllerHealth(options) {
            return localVarFp.whatsAppWebhookControllerHealth(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WhatsAppWebhookApi - object-oriented interface
 * @export
 * @class WhatsAppWebhookApi
 * @extends {BaseAPI}
 */
export class WhatsAppWebhookApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppWebhookApi
     */
    whatsAppWebhookControllerHandleVerify(options) {
        return WhatsAppWebhookApiFp(this.configuration).whatsAppWebhookControllerHandleVerify(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppWebhookApi
     */
    whatsAppWebhookControllerHandleWebhook(options) {
        return WhatsAppWebhookApiFp(this.configuration).whatsAppWebhookControllerHandleWebhook(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsAppWebhookApi
     */
    whatsAppWebhookControllerHealth(options) {
        return WhatsAppWebhookApiFp(this.configuration).whatsAppWebhookControllerHealth(options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map